// stolen, i mean.. borrowed from https://css-tricks.com/how-to-animate-the-details-element/
class Accordion {
  constructor({
    el,
    duration = 250,
    easing = 'linear',
    onOpen = () => {},
    onClose = () => {}
  } = {}) {
    this.el = el;
    this.summary = el.querySelector('summary');
    this.content = el.querySelector('[data-accordion-content]');
    this.animationDuration = duration;
    this.animationEasing = easing;

    // Store the animation object (so we can cancel it if needed)
    this.animation = null;
    this.isClosing = false;
    this.isExpanding = false;
    this.summary.addEventListener('click', (e) => this.onClick(e, onOpen, onClose));

    this.summary.setAttribute('role', 'button');
    this.summary.setAttribute('aria-expanded', el.hasAttribute('open'));

    if (this.summary.nextElementSibling.getAttribute('id')) {
      this.summary.setAttribute('aria-controls', this.summary.nextElementSibling.id);
    }

    if (this.summary.closest('.header-drawer')) return;
    this.summary.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  onClick(e, onOpen, onClose) {
    e.currentTarget.setAttribute('aria-expanded', !e.currentTarget.closest('details').hasAttribute('open'));

    if(
      this.el.classList.contains('facets__disclosure') ||
      this.el.classList.contains('mobile-facets__details') ||
      this.el.classList.contains('menu-drawer-container') ||
      this.el.classList.contains('header-menu__dropdown')
    ) return;

    e.preventDefault();

    // Add an overflow on the <details> to avoid content overflowing
    this.el.style.overflow = 'hidden';
    // Check if the element is being closed or is already closed
    if (this.isClosing || !this.el.open) {
      onOpen(this.el);
      this.open();
    // Check if the element is being opened or is already open
    } else if (this.isExpanding || this.el.open) {
      onClose(this.el);
      this.shrink();
    }
  }

  shrink() {
    this.isClosing = true;
    const startHeight = `${this.el.offsetHeight}px`;
    const endHeight = `${this.summary.offsetHeight}px`;

    // If there is already an animation running
    if (this.animation) {
      this.animation.cancel();
    }

    this.animation = this.el.animate({
      // Set the keyframes from the startHeight to endHeight
      height: [startHeight, endHeight]
    }, {
      duration: this.animationDuration,
      easing: this.animationEasing
    });

    // When the animation is complete, call onAnimationFinish()
    this.animation.onfinish = () => this.onAnimationFinish(false);
    // If the animation is cancelled, isClosing variable is set to false
    this.animation.oncancel = () => this.isClosing = false;
  }

  open() {
    // Apply a fixed height on the element
    this.el.style.height = `${this.el.offsetHeight}px`;
    // Force the [open] attribute on the details element
    this.el.open = true;
    // Wait for the next frame to call the expand function
    window.requestAnimationFrame(() => this.expand());
  }

  expand() {
    // Set the element as "being expanding"
    this.isExpanding = true;
    // Get the current fixed height of the element
    const startHeight = `${this.el.offsetHeight}px`;
    // Calculate the open height of the element (summary height + content height)
    const endHeight = `${this.summary.offsetHeight + this.content.offsetHeight}px`;

    // If there is already an animation running
    if (this.animation) {
      // Cancel the current animation
      this.animation.cancel();
    }

    // Start a WAAPI animation
    this.animation = this.el.animate({
      // Set the keyframes from the startHeight to endHeight
      height: [startHeight, endHeight]
    }, {
      duration: this.animationDuration,
      easing: this.animationEasing
    });
    // When the animation is complete, call onAnimationFinish()
    this.animation.onfinish = () => this.onAnimationFinish(true);
    // If the animation is cancelled, isExpanding variable is set to false
    this.animation.oncancel = () => this.isExpanding = false;
  }

  onAnimationFinish(open) {
    this.el.open = open;
    // Clear the stored animation
    this.animation = null;

    this.isClosing = false;
    this.isExpanding = false;
    // Remove the overflow hidden and the fixed height
    this.el.style.height = this.el.style.overflow = '';
  }
}

const trapFocusHandlers = {};

const trapFocus = (container, elementToFocus = container) => {
  var elements = theme.utils.getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  theme.utils.removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = () => {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = (event) => {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();  
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch (e) {
  focusVisiblePolyfill();
}

const focusVisiblePolyfill = () => {
  const navKeys = ['ARROWUP', 'ARROWDOWN', 'ARROWLEFT', 'ARROWRIGHT', 'TAB', 'ENTER', 'SPACE', 'ESCAPE', 'HOME', 'END', 'PAGEUP', 'PAGEDOWN']
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener('focus', () => {
    if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

    if (mouseClick) return;

    currentFocusedElement = document.activeElement;
    currentFocusedElement.classList.add('focused');

  }, true);
}

const onKeyUpEscape = (event) => {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true })

    this.querySelectorAll('button').forEach(
      (button) => button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }
}

customElements.define('quantity-input', QuantityInput);

/*
 * Shopify Common JS
 *
 */
if ((typeof window.Shopify) == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function(fn, scope){
  return function(){
    return fn.apply(scope, arguments);
  }
};

Shopify.setSelectorByValue = (selector, value) => {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = (target, eventName, callback) => {
  target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent('on' + eventName, callback);
};

Shopify.postLink = (path, options) => {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for (var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (country_domid, province_domid, options) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler, this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  }
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach(summary => summary.addEventListener('click', this.onSummaryClick.bind(this)));
    this.querySelectorAll('button:not(.localization-selector)').forEach((button) =>
      button.addEventListener('click', this.onCloseButtonClick.bind(this))
    );
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary')) : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest('.has-submenu');
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

    const addTrapFocus = () => {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);

      if (window.matchMedia('(max-width: 990px)').matches) {
        document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
      }
    } else {
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
        parentMenuElement && parentMenuElement.classList.add('submenu-open');
        !reducedMotion || reducedMotion.matches ? addTrapFocus() : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);

    document.body.classList.add('overflow-hidden');
    document.body.classList.add(`facets-drawer--open`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove('menu-opening');
    this.mainDetailsToggle.querySelectorAll('details').forEach(details => {
      details.removeAttribute('open');
      details.classList.remove('menu-opening');
    });
    this.mainDetailsToggle.querySelectorAll('.submenu-open').forEach(submenu => {
      submenu.classList.remove('submenu-open');
    });
    theme.utils.removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);

    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);

    document.body.classList.remove('overflow-hidden');
    document.body.classList.remove(`facets-drawer--open`);
  }

  onFocusOut() {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement)) this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest('.submenu-open');
    parentMenuElement && parentMenuElement.classList.remove('submenu-open');
    detailsElement.classList.remove('menu-opening');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    theme.utils.removeTrapFocus(detailsElement.querySelector('summary'));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    }

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.querySelector('.section__header');
    document.documentElement.style.setProperty('--header-bottom-position', `${parseInt(this.header.getBoundingClientRect().bottom)}px`);
    this.header.classList.add('menu-open');

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`header-drawer--open`);
  }

  closeMenuDrawer(event, elementToFocus) {
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove('menu-open');
  }
}

customElements.define('header-drawer', HeaderDrawer);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    theme.utils.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
      if (focus) deferredElement.focus();
      if (deferredElement.nodeName == 'VIDEO' && deferredElement.getAttribute('autoplay')) {
        // force autoplay for safari
        deferredElement.play();
      }
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      fetch(this.dataset.url)
        .then(response => response.text())
        .then(text => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('product-recommendations');

          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
            window.dispatchEvent(new Event("prodigy:product-recommendations:init"));
          }

          if (!this.querySelector('slideshow-component') && this.classList.contains('complementary-products')) {
            this.remove();
          }
        })
        .catch(e => {
          console.error(e);
        });
    }

    new IntersectionObserver(handleIntersection.bind(this), { rootMargin: '0px 0px 400px 0px' }).observe(this);
  }
}

customElements.define('product-recommendations', ProductRecommendations);

window.theme = window.theme || {};

window.theme.durations = {
  short: 100,
  default: 200,
  medium: 350,
  long: 500
}

window.theme.config = {
  maxPagination: 10
}

window.theme.settings = {
  onlyAnimateOnce: document.body.hasAttribute('data-scroll-animation-once'),
  scrollAnimationsEnabled: document.body.hasAttribute('data-scroll-animations-enabled'),
  wishlist: {
    openAfterAdd: document.body.hasAttribute('data-wishlist-open-after-add'),
    enabled: document.body.hasAttribute('data-wishlist-enabled')
  }
};

theme.accordions = (function(){
  const createAccordion = (el) => {
    new Accordion({ el });
  }

  const initAccordions = () => {
    document.querySelectorAll('[id^="Details-"]').forEach((accordion) => createAccordion( accordion ));
  }

  const init = () => {
    initAccordions()
  }

  return {
    init,
    createAccordion,
    initAccordions
  }
})();

theme.ageVerification = (function(){
  const selectors = {
    modalId: 'age-verification',
    dropdownWrapper: '.age__dropdowns',
    select: '.select__select',
    submitButton: 'button[type="submit"]',
    rejectButton: '#reject',
    month: '[name="month"]',
    day: '[name="day"]',
    year: '[name="year"]'
  };

  const daysInMonth = (month, year = new Date().getFullYear()) => new Date(year, month, 0).getDate();

  selectors.modalWrapper = `.${selectors.modalId}__wrapper`;

  let modalWrapper = document.querySelector(selectors.modalWrapper);
  let dropdownWrapper = document.querySelector(selectors.dropdownWrapper);

  const init = () => {
    initAgeVerificationModal();
    initRejectButton();

    if(document.querySelector('[data-visual-type="dropdowns"]')){
      initDropdowns();
    }else{
      initButtons();
    }
  }

  const initDropdowns = () => {
    if(dropdownWrapper){
      let ageLimit = parseInt(modalWrapper.dataset.ageLimit);
      let monthSelect = dropdownWrapper.querySelector(selectors.month);
      let daySelect = dropdownWrapper.querySelector(selectors.day);
      let yearSelect = dropdownWrapper.querySelector(selectors.year);

      modalWrapper.querySelector(selectors.submitButton).addEventListener('click', function(){
        let birthday = new Date(`${yearSelect.value}-${monthSelect.value}-${daySelect.value}`);
        let age = getAge(birthday);

        age >= ageLimit ? modalSuccess() : modalFailure();
      });

      dropdownWrapper.querySelectorAll(selectors.select).forEach(select => {
        select.addEventListener('change', function(){
          if(monthSelect.value !== '' && daySelect.value !== '' && yearSelect.value !== ''){
            modalWrapper.querySelector(selectors.submitButton).disabled = false;
          }
        });
      });

      monthSelect.addEventListener('change', function(){
        let daysInCurrentMonth = yearSelect.value === '' ? daysInMonth(monthSelect.value) : daysInMonth(monthSelect.value, yearSelect.value);

        let options = '<option value="" disabled selected>Day</option>'; // Add default option

        for (let i = 1; i <= daysInCurrentMonth; i++) {
          // Ensure two-digit format (e.g., 01, 02)
            const day = i.toString().padStart(2, '0');
            if(daySelect.value <= daysInCurrentMonth && day === daySelect.value){
              options += '<option value="' + day + '" selected>' + day + '</option>';
            }else{
              options += '<option value="' + day + '">' + day + '</option>';
            }
        }

        day.innerHTML = options;        
      })
    }
  }

  const initButtons = () => {
    modalWrapper.querySelector(selectors.submitButton).addEventListener('click', function(){
      modalSuccess();
    });
  }

  const initRejectButton = () => {
    modalWrapper.querySelector(selectors.rejectButton).addEventListener('click', function(){
      modalFailure();
    });
  }

  const modalSuccess = () => {
    let cookieDuration = parseInt(modalWrapper.dataset.cookieDuration);
    theme.cookies.set('prodigy:age-verification', true, cookieDuration);
    theme.modals.close(selectors.modalId);
  }

  const modalFailure = () => {
    window.dispatchEvent(new CustomEvent('prodigy:age-verification:failure'));

    if(history.length > 1){
      history.back();
    }else{
      window.location = window.ageVerification.redirectUrl;
    }
  }

  const initAgeVerificationModal = () => {
    if(
      document.getElementById(selectors.modalId) &&
      !theme.cookies.get('prodigy:age-verification') &&
      document.querySelector(theme.ageVerification.selectors.modalWrapper).dataset.enabled === "true"
    ){
      theme.modals.open(selectors.modalId, {
        disableEsc: true
      });
    }
  }

  const getAge = (born) => {
    var now = new Date();
    var birthday = new Date(now.getFullYear(), born.getMonth(), born.getDate());

    if (now >= birthday)
      return now.getFullYear() - born.getFullYear();
    else
      return now.getFullYear() - born.getFullYear() - 1;
  }

  return {
    init,
    selectors
  }
})();

theme.anchorLinks = (function(){
  let headerHeight = 0;
  let stickyHeaderType = document.body.getAttribute('data-header-sticky-type');

  const selectors = {
    anchorLinks: '[href^="#"]:not(.ignore-anchor)'
  };

  const init = () => {
    // calculate header height after announcement bar has a height    
    if(document.querySelector('.section__announcement-bar')){
      window.addEventListener('prodigy:announcement:loaded', function(){
        calculateHeaderHeight();
        initAnchorLinks();
      });
    }else{
      calculateHeaderHeight();
      initAnchorLinks();
    }
  }

  const calculateHeaderHeight = () => {
    if(document.querySelector('.header-group')){
      headerHeight = document.querySelector('.header-group').offsetHeight;
    }else{
      headerHeight = document.querySelector('#shopify-section-main-password-header').offsetHeight;
    }
  }

  const clickHandler = (anchor) => {
    anchor.addEventListener('click', function (event) {
      event.preventDefault();

      let target = document.querySelector(this.getAttribute('href'));
      let targetPosition = target.getBoundingClientRect().top;
      let anchorHref = anchor.getAttribute('href').replace('#','');
      let scrollDirection = window.scrollY > (targetPosition + window.scrollY) ? 'up' : 'down';

      if( (stickyHeaderType === 'on-scroll-up' && scrollDirection === 'up') || stickyHeaderType === 'always'){
        targetPosition -= headerHeight;
      }

      window.scrollTo({
        top: targetPosition + window.scrollY,
        behavior: 'smooth'
      });

      const detail = {
        href: anchorHref,
        el: anchor,
        event,
        target: document.getElementById(anchorHref),
        scrollDirection
      };

      window.dispatchEvent( new CustomEvent('prodigy:anchor-link-clicked', { detail }) );
    });    
  }

  const initAnchorLinks = () => {
    document.querySelectorAll(selectors.anchorLinks).forEach((anchor) => clickHandler(anchor));
  }

  return {
    init,
    clickHandler
  }
})();

theme.cart = (function(){
  var selectors = {
    cartItems: 'cart-drawer-items',
    cartDrawerFooter: '.cart-drawer__footer',
    cartFooter: '.cart__footer',
    freeShipping: {
      wrapper: '.free-shipping__wrapper',
      text: '.free-shipping__text',
      progress: '.free-shipping__progress',
      progressInner: '.free-shipping__progress-inner'
    },
    discounts: {
      wrapper: '.discount-code__wrapper',
      removeDiscount: '.discounts__discount',
      codeInput: '.discount-code-input',
      applyDiscount: '.apply-discount-btn',
      error: '.discount-code__error'
    },
    shippingCalculator: {
      wrapper: '.shipping-calc',
      button: '.shipping-calc__btn',
      alert: '.shipping-calc__alert',
      provinceWrapper: '.shipping-calc__province-wrapper',
      country: '.shipping-calc__country',
      province: '.shipping-calc__province',
      zip: '.shipping-calc__zip'
    },
    floatingCartIcon: {
      button: '.floating-cart-icon',
      id: '#floating-cart-icon'
    }
  }

  const init = () => {
    initDiscount();
    initShippingCalculator();
  }

  const initDiscount = () => {
    removeDiscountButtons();
    applyDiscountButton();
  }

  const replaceVariables = (string, threshold, cartPrice) => {
    let stringWithValues = string.replace(/\|\|amount\|\|/, theme.currency.formatMoney(threshold));
    stringWithValues = stringWithValues.replace(/\|\|remaining\|\|/, theme.currency.formatMoney(threshold - cartPrice));

    return stringWithValues;
  }

  const updateFreeShipping = (cart) => {
    let completeText = window.freeShippingStrings.completeText;
    let startingText = window.freeShippingStrings.startingText;
    let freeShippingBars = document.querySelectorAll(selectors.freeShipping.wrapper);

    freeShippingBars.forEach(freeShippingBar => {
      let threshold = (parseInt(freeShippingBar.dataset.amount) * 100) * parseFloat(theme.currency.rate);
      let cartPrice = cart.total_price;
      let percentProgress = (cartPrice / threshold) * 100;
      let percentRemaining = 100 - percentProgress;

      completeText = replaceVariables(completeText, threshold, cartPrice);
      startingText = replaceVariables(startingText, threshold, cartPrice);

      let updatedText = startingText;
      if(percentProgress >= 100){
        updatedText = completeText;
      }

      // update data
      freeShippingBar.querySelector(selectors.freeShipping.text).innerHTML = updatedText;
      if( freeShippingBar.querySelector(selectors.freeShipping.progressInner) ){
        freeShippingBar.querySelector(selectors.freeShipping.progressInner).style.width = `${percentProgress}%`;
      }
      if(freeShippingBar.querySelector(`${selectors.freeShipping.progress} svg`) ){
        freeShippingBar.querySelector(`${selectors.freeShipping.progress} .circle__progress`).style.strokeDashoffset = `${percentRemaining <= 0 ? 0 : percentRemaining}`;
      }
    })
  }

  const getCurrentDiscounts = () => {
    let discounts = [];
    let discountButtons = document.querySelectorAll(`${selectors.cartDrawerFooter} ${selectors.discounts.removeDiscount}`);

    if(document.body.classList.contains('template--cart')){
      discountButtons = document.querySelectorAll(`${selectors.cartFooter} ${selectors.discounts.removeDiscount}`)
    }

    discountButtons.forEach(d => {
      discounts.push(d.dataset.discountCode);
    });

    return discounts;
  }  

  const applyDiscountButton = () => {
    const buttons = document.querySelectorAll(selectors.discounts.applyDiscount);

    if(buttons){
      buttons.forEach(button => {
        const wrapper = button.closest(selectors.discounts.wrapper);
        const input = wrapper.querySelector(selectors.discounts.codeInput);

        button.addEventListener('click', async function(e){
            e.preventDefault();
            let code = input.value;

            if(code != ''){
              theme.utils.setButtonLoading(button);
            }

            applyDiscountCode(code, function(res){
              const cartPage = document.body.classList.contains('template--cart');

              if(res.error){
                displayDiscountError(wrapper, res.message);
              }else{
                let discountNotApplicable = res.discount_codes.find(d => d.code === code && d.applicable === false);
                if(discountNotApplicable){
                  displayDiscountError(wrapper, window.cartStrings.discount.error);
                }else{
                  if(cartPage){
                    location.reload();
                  }else{
                    let cartItems = document.querySelector(`cart-drawer ${selectors.cartItems}`);
                    cartItems.reloadCart({}, function(){
                      theme.utils.setButtonFinished(button);
                    });
                  }

                  input.value = '';
                }
              }
              theme.utils.setButtonFinished(button);
            });
          });
      })
    }
  }

  const displayDiscountError = (wrapper, error) => {
    console.error( theme.utils.stripHTMLTags(error) );
    let errorMessage = wrapper.querySelector(selectors.discounts.error);
    if(errorMessage.textContent === ''){
      errorMessage.classList.toggle('mb-2');
    }
    errorMessage.innerHTML = error;
  }

  const removeDiscountButtons = () =>{
    document.querySelectorAll(selectors.discounts.removeDiscount).forEach(button => {
      button.addEventListener('click', function(){
        theme.utils.setButtonLoading(button);

        removeDiscountCode( button.dataset.discountCode, function(){
          if(document.body.classList.contains('template--cart')){
            location.reload();
          }else{
            let cartItems = document.querySelector(`cart-drawer ${selectors.cartItems}`);
            cartItems.reloadCart();
          }
        });
      })
    })
  }

  const applyDiscountCode = ( discountCode, callback ) =>{
    if(discountCode != ''){
      let existingDiscounts = getCurrentDiscounts();
      if (existingDiscounts.includes(discountCode)) return callback({
        error: true,
        message: window.cartStrings.discount.alreadyAdded.replace('[code]', discountCode)
      });

      var formData = new FormData();
      formData.append("discount", [...existingDiscounts, discountCode].join(','));

      fetch(window.Shopify.routes.root + 'cart/update.js', {
        method: 'POST',
        body: formData
      })
      .then(response => response.json())
      .then(async(response) => {
        typeof callback === 'function' && callback(response);
      });
    }
  }

  const clearAllDiscounts = ( callback ) => {
    var formData = new FormData();
    formData.append('discount', '');

    fetch(window.Shopify.routes.root + "cart/update.js", {
      method: 'POST',
      body: formData
    }).then((res) => {
      typeof callback === 'function' && callback(res)
    });
  }

  const removeDiscountCode = ( code, callback ) => {
    var formData = new FormData();
    let existingDiscounts = getCurrentDiscounts();
    const index = existingDiscounts.indexOf(code);
    if (index === -1) return;

    existingDiscounts.splice(index, 1);        
    formData.append("discount", existingDiscounts.join(','));

    fetch(window.Shopify.routes.root + "cart/update.js", {
      method: 'POST',
      body: formData
    }).then((res) => {
      typeof callback === 'function' && callback(res)
    });    
  }

  const shippingCalculatorSelect = () =>{
    const countrySelects = document.querySelectorAll(selectors.shippingCalculator.country);

    if(countrySelects){
      countrySelects.forEach(countrySelect => {
        let selectedValue;
        let wrapper = countrySelect.closest(selectors.shippingCalculator.wrapper);
        let wrapper_id = wrapper.dataset.objectId;

        countrySelect.addEventListener("change", (event) => {
          // Get the selected option
          selectedValue = event.target.selectedOptions[0];

          // Find the option with the selected value and set it as selected
          const optionToSelect = Array.from(countrySelect.options).find(option => option.value === selectedValue.value);
          if (optionToSelect) {
            optionToSelect.selected = true;

            // Check if selectedValue has data-provinces
            const dataProvinces = selectedValue.getAttribute('data-provinces');
            if (dataProvinces) {
              const allProvinceWrappers = document.querySelectorAll(selectors.shippingCalculator.provinceWrapper);
              const dataProvincesArr = dataProvinces.split(" ");
              if(dataProvincesArr.length > 1) {
                // Toggle the style display for allProvinceWrappers
                allProvinceWrappers.forEach(wrapper => {
                    wrapper.style.display = 'block';
                });
              } else {
                // Toggle the style display for allProvinceWrappers
                allProvinceWrappers.forEach(wrapper => {
                    wrapper.style.display = 'none';
                });
              }
            }
          }

          let countrySelector = `${selectors.shippingCalculator.country.replace('#','').replace('.','')}--${wrapper_id}`
          let provinceSelector = `${selectors.shippingCalculator.province.replace('#','').replace('.','')}--${wrapper_id}`
          let provinceWrapper = `${selectors.shippingCalculator.provinceWrapper.replace('#','').replace('.','')}--${wrapper_id}`

          new Shopify.CountryProvinceSelector(countrySelector, provinceSelector, {
            hideElement: provinceWrapper
          });
        });
      });
    }
  }

  // Generate Shipping rates
  // https://shopify.dev/docs/api/ajax/reference/cart#generate-shipping-rates
  // adapted from https://community.shopify.com/c/shopify-discussions/shipping-calculator-product-and-or-cart-page-local-delivery/m-p/2368687/highlight/true#M408969
  const generateShippingRates = async ( wrapper ) => {
    let btn = wrapper.querySelector(selectors.shippingCalculator.button);
    theme.utils.setButtonLoading(btn);

    wrapper.querySelector(selectors.shippingCalculator.alert).innerHTML = ''
    wrapper.querySelector(selectors.shippingCalculator.alert).setAttribute('hidden', 'hidden');

    const country = wrapper.querySelector(selectors.shippingCalculator.country).value
    const province = wrapper.querySelector(selectors.shippingCalculator.province).value
    const zip = wrapper.querySelector(selectors.shippingCalculator.zip).value

    const prepareResponse = await fetch(`/cart/prepare_shipping_rates.json?shipping_address[zip]=${zip}&shipping_address[country]=${country}&shipping_address[province]=${province}`, {
      method: 'POST'
    })

    if (prepareResponse.ok) {
      const asyncResponse = await fetch(`/cart/async_shipping_rates.json?shipping_address[zip]=${zip}&shipping_address[country]=${country}&shipping_address[province]=${province}`)
      const data = await asyncResponse.json()
      let html = ''

      if(asyncResponse.ok){
        wrapper.querySelector(selectors.shippingCalculator.alert).classList.remove('calc-alert-danger', 'calc-alert-success')

        if (data.shipping_rates.length) {
          data.shipping_rates.forEach(elem => {
            let cost = `${elem.price} ${elem.currency}`
            if(elem.price === '0.00'){
              cost = 'Free';
            }
            html += `<li>${elem.presentment_name}: <strong>${cost}</strong></li>`
          })

          wrapper.querySelector(selectors.shippingCalculator.alert).classList.add('calc-alert-success')
          wrapper.querySelector(selectors.shippingCalculator.alert).innerHTML = `<ul>${html}</ul>`
        } else {
          wrapper.querySelector(selectors.shippingCalculator.alert).classList.add('calc-alert-danger')
          wrapper.querySelector(selectors.shippingCalculator.alert).innerHTML = `<p>${window.shippingStrings.noResults}</p>`
        }

        wrapper.querySelector(selectors.shippingCalculator.alert).removeAttribute('hidden')
      }else{
        let html = ''

        for (const [key, value] of Object.entries(data)) {
          html += `<li><strong class="capitalize">${key}</strong>: ${value.toString()}</li>`
        }

        wrapper.querySelector(selectors.shippingCalculator.alert).classList.remove('calc-alert-danger', 'calc-alert-success')
        wrapper.querySelector(selectors.shippingCalculator.alert).classList.add('calc-alert-danger')
        wrapper.querySelector(selectors.shippingCalculator.alert).innerHTML = `<ul>${html}</ul>`
        wrapper.querySelector(selectors.shippingCalculator.alert).removeAttribute('hidden')
      }
    } else {
      const data = await prepareResponse.json()
      let html = ''

      for (const [key, value] of Object.entries(data)) {
        html += `<li><strong class="capitalize">${key}:</strong> ${value.toString()}</li>`
      }

      wrapper.querySelector(selectors.shippingCalculator.alert).classList.remove('calc-alert-danger', 'calc-alert-success')
      wrapper.querySelector(selectors.shippingCalculator.alert).classList.add('calc-alert-danger')
      wrapper.querySelector(selectors.shippingCalculator.alert).innerHTML = `<ul>${html}</ul>`
      wrapper.querySelector(selectors.shippingCalculator.alert).removeAttribute('hidden')
    }

    theme.utils.setButtonFinished(btn);
  }

  const shippingCalculatorButton = () => {
    let buttons = document.querySelectorAll(selectors.shippingCalculator.button);

    if(buttons){
      buttons.forEach(button => {
        let wrapper = button.closest(selectors.shippingCalculator.wrapper);
        button.addEventListener('click', function(e){
          theme.cart.generateShippingRates( wrapper );
        });
      });
    }
  }

  const initShippingCalculator = () => {
    shippingCalculatorSelect();
    shippingCalculatorButton();
  }

  return {
    init,
    updateFreeShipping,
    replaceVariables,
    removeDiscountButtons,
    clearAllDiscounts,
    removeDiscountCode,
    getCurrentDiscounts,
    applyDiscountButton,
    applyDiscountCode,
    generateShippingRates,
    selectors
  }
})();

theme.cookies = (function(){
  const get = (name) => {
    return document.cookie.match('(^|;)\\s*' + name + '\\s*=\\s*([^;]+)')?.pop() || ''
  }

  const set = (name, value, days) => {
    var expires = "";
    if (days) {
      var date = new Date();
      date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
      expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + (value || "") + expires + "; path=/";
  }

  return {
    get,
    set,
  }
})();

theme.countdown = (function(){
  var selectors = {
    countdowns: '[data-block-type="countdown"]',
    interval: '.interval__string',
    amount: '.amount',
    class: {
      initialized: 'countdown--initialized',
      completed: 'countdown--completed'
    },
    days: '#days',
    hours: '#hours',
    minutes: '#minutes',
    seconds: '#seconds'
  }

  const init = () => {
    let countdowns = document.querySelectorAll(selectors.countdowns);

    countdowns.forEach(countdown => {
      if (countdown.querySelector('[data-date]')) {
        initCountdown(countdown.querySelector('[data-date]'));
      }
    })
  }

  const checkPluralization = (count, name) => {
    let string = window.countdownStrings[name].plural;

    if(count === 1){
      string = window.countdownStrings[name].single;
    }

    return string;
  }

  const initCountdown = (countdown) => {
    let countdownDate = new Date(countdown.dataset.date.replace(/-/g, '/')).getTime();
    let now = new Date().getTime();
    let timeToGo = countdownDate - now;

    if (timeToGo < 1000) {
      countdown.classList.add(selectors.class.completed);
    }

    let countdownInterval = setInterval(() => {
      let now = new Date().getTime();
      let timeToGo = countdownDate - now;
      const dayCalc = 1000 * 60 * 60 * 24;

      var days = Math.floor(timeToGo / dayCalc);
      var hours = Math.floor((timeToGo % dayCalc) / (1000 * 60 * 60));
      var minutes = Math.floor((timeToGo % (1000 * 60 * 60)) / (1000 * 60));
      var seconds = Math.floor((timeToGo % (1000 * 60)) / 1000);

      countdown.querySelector(`${selectors.days} ${selectors.amount}`).innerHTML = days;
      countdown.querySelector(`${selectors.days} ${selectors.interval}`).innerHTML = checkPluralization(days, "days");

      countdown.querySelector(`${selectors.hours} ${selectors.amount}`).innerHTML = hours;
      countdown.querySelector(`${selectors.hours} ${selectors.interval}`).innerHTML = checkPluralization(hours, "hours");

      countdown.querySelector(`${selectors.minutes} ${selectors.amount}`).innerHTML = minutes;
      countdown.querySelector(`${selectors.minutes} ${selectors.interval}`).innerHTML = checkPluralization(minutes, "minutes");

      countdown.querySelector(`${selectors.seconds} ${selectors.amount}`).innerHTML = seconds;
      countdown.querySelector(`${selectors.seconds} ${selectors.interval}`).innerHTML = checkPluralization(seconds, "seconds");

      if(!countdown.classList.contains(selectors.class.initialized)){
        countdown.classList.add(selectors.class.initialized);
      }

      if (timeToGo < 1000) {
        clearInterval(countdownInterval);
        countdown.classList.add(selectors.class.completed);
      }
    }, 1000);
  }

  return {
    selectors,
    init
  }
})();

theme.currency = (function(){
  const currencyCode = window.currencyCode;
  const rate = window.Shopify.currency.rate;
  const moneyFormat = `${currencyCode}{{amount_no_zeroes}}`;

  const formatMoney = (cents, format = moneyFormat) => {
    if (typeof cents == 'string') { cents = cents.replace('.', ''); }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = (format || this.money_format);

    const defaultOption = (opt, def) => {
      return (typeof opt == 'undefined' ? def : opt);
    }

    const formatWithDelimiters = (number, precision, thousands, decimal) => {
      precision = defaultOption(precision, 2);
      thousands = defaultOption(thousands, ',');
      decimal = defaultOption(decimal, '.');

      if (isNaN(number) || number == null) { return 0; }

      number = (number / 100.0).toFixed(precision);

      var parts = number.split('.'),
        dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
        cents = parts[1] ? (decimal + parts[1]) : '';

      return dollars + cents;
    }

    var match = formatString.match(placeholderRegex);

    if (match) {
      switch (match[1]) {
        case 'amount':
          value = formatWithDelimiters(cents, 2);
          break;
        case 'amount_no_zeroes':
          value = formatWithDelimiters(cents, 2).replace('.00', '');
          break;
        case 'amount_no_decimals':
          value = formatWithDelimiters(cents, 0);
          break;
        case 'amount_with_comma_separator':
          value = formatWithDelimiters(cents, 2, '.', ',');
          break;
        case 'amount_no_decimals_with_comma_separator':
          value = formatWithDelimiters(cents, 0, '.', ',');
          break;
      }
    }

    return formatString.replace(placeholderRegex, value);
  }

  return {
    formatMoney,
    moneyFormat,
    currencyCode,
    rate
  }
})();

theme.gridLayoutSwitcher = (function(){
  const selectors = {
    switcher: '.grid-switcher',
    productGrid: '.product-grid',
    section: '.section',
    activeClass: 'active',
    storageKey: 'prodigy:column-count'
  }

  const initLayout = () => {
    const storageColumnCount = localStorage.getItem(selectors.storageKey) || false;

    if(!storageColumnCount) {
      const activeButton = document.querySelector(`${selectors.switcher}.${selectors.activeClass}`);
      const currentColumnCount = parseInt(activeButton.dataset.columnCount);
      localStorage.setItem(selectors.storageKey, currentColumnCount);
    }else{
      const buttons = document.querySelectorAll(selectors.switcher);
      const section = buttons[0].closest(selectors.section);
      const productGrid = section.querySelector(selectors.productGrid);
  
      buttons.forEach(button => button.classList.remove(selectors.activeClass));
      document.querySelector(`${selectors.switcher}[data-column-count="${storageColumnCount}"]`).classList.add(selectors.activeClass);
      productGrid.setAttribute('data-columns-desktop', storageColumnCount);
    }
  }

  const initButtons = () => {
    const buttons = document.querySelectorAll(selectors.switcher);
    const section = buttons[0].closest(selectors.section);
    const productGrid = section.querySelector(selectors.productGrid);

    buttons.forEach(button => {  
      button.addEventListener('click', function(e){
        let switcher = e.target.closest(selectors.switcher);
        productGrid.setAttribute('data-columns-desktop', switcher.dataset.columnCount);
        buttons.forEach(button => button.classList.remove(selectors.activeClass));
        switcher.classList.add(selectors.activeClass);
        localStorage.setItem(selectors.storageKey, switcher.dataset.columnCount);
      });
    });
  }

  const reinit = () => {
    initLayout();
    initButtons();
  }

  const init = () => {
    const buttons = document.querySelectorAll(selectors.switcher);
    
    if(buttons.length){
      reinit();
      addEventHandlers();
    }
  }

  const addEventHandlers = () => {
    window.addEventListener('prodigy:facet-filters:reloaded', function(){
      reinit();
    });
  }

  return {
    init,
    reinit,
    initButtons,
    initLayout,
    addEventHandlers
  }
})();

theme.header = (function(){
  const scroll = () => {
    let headerBounds = {};
    let currentScrollTop = 0;
    let header = document.querySelector('.section__header');

    let observer = new IntersectionObserver((entries, observer) => {
      headerBounds = entries[0].intersectionRect;
      observer.disconnect();
    });

    observer.observe(header);

    const scrollHandler = () => {
      const scrollTop = window.scrollY == 0 ? document.documentElement.scrollTop : window.scrollY;
      let scrollThreshold = headerBounds.bottom || header.offsetHeight;

      if (scrollTop > currentScrollTop && scrollTop > scrollThreshold) {
        document.body.classList.add('scrolled-past-header');
      } else if (scrollTop < currentScrollTop && scrollTop > scrollThreshold) {
        document.body.classList.add('scrolled-past-header');
      } else if (scrollTop <= headerBounds.top) {
        document.body.classList.remove('scrolled-past-header');
      }

      currentScrollTop = scrollTop;
    }

    window.addEventListener('scroll', scrollHandler, false);
  }

  const hover = () => {
    let header = document.querySelector('.section__header');

    header.addEventListener('mouseenter', function(){
      document.body.classList.add('header--hovered');
      window.dispatchEvent( new CustomEvent('prodigy:header:hover-enter') );
    }, false);

    header.addEventListener('mouseleave', function(){
      document.body.classList.remove('header--hovered');
      window.dispatchEvent( new CustomEvent('prodigy:header:hover-leave') );
    }, false);

  }

  const setHeight = () => {
    let header = document.querySelector('.section__header');
    document.documentElement.style.setProperty('--header--height', `${header.offsetHeight}px`);
  }

  const init = () => {
    setHeight();
    window.matchMedia('(max-width: 990px)').addEventListener('change', setHeight.bind(this));
    scroll();
    hover();
  }

  return {
    init,
    scroll,
    hover,
    setHeight
  }
})();

theme.maps = (function(){
  const mapsProvider = window.maps.provider;

  var selectors = {
    mapSections: '[data-map]'
  };

  if(mapsProvider === 'google'){
    var styles = [
      { name: 'normal', styles: [{ "featureType": "all", "elementType": "labels.text", "stylers": [ { "color": "#878787" } ] }, { "featureType": "all", "elementType": "labels.text.stroke", "stylers": [ { "visibility": "off" } ] }, { "featureType": "landscape", "elementType": "all", "stylers": [ { "color": "#f9f5ed" } ] }, { "featureType": "road.highway", "elementType": "all", "stylers": [ { "color": "#f5f5f5" } ] }, { "featureType": "road.highway", "elementType": "geometry.stroke", "stylers": [ { "color": "#c9c9c9" } ] }, { "featureType": "water", "elementType": "all", "stylers": [ { "color": "#aee0f4" } ] }] },
      { name: 'light', styles: [{ "featureType": "water", "elementType": "geometry", "stylers": [ { "color": "#e9e9e9" }, { "lightness": 17 } ] }, { "featureType": "landscape", "elementType": "geometry", "stylers": [ { "color": "#f5f5f5" }, { "lightness": 20 } ] }, { "featureType": "road.highway", "elementType": "geometry.fill", "stylers": [ { "color": "#ffffff" }, { "lightness": 17 } ] }, { "featureType": "road.highway", "elementType": "geometry.stroke", "stylers": [ { "color": "#ffffff" }, { "lightness": 29 }, { "weight": 0.2 } ] }, { "featureType": "road.arterial", "elementType": "geometry", "stylers": [ { "color": "#ffffff" }, { "lightness": 18 } ] }, { "featureType": "road.local", "elementType": "geometry", "stylers": [ { "color": "#ffffff" }, { "lightness": 16 } ] }, { "featureType": "poi", "elementType": "geometry", "stylers": [ { "color": "#f5f5f5" }, { "lightness": 21 } ] }, { "featureType": "poi.park", "elementType": "geometry", "stylers": [ { "color": "#dedede" }, { "lightness": 21 } ] }, { "elementType": "labels.text.stroke", "stylers": [ { "visibility": "on" }, { "color": "#ffffff" }, { "lightness": 16 } ] }, { "elementType": "labels.text.fill", "stylers": [ { "saturation": 36 }, { "color": "#333333" }, { "lightness": 40 } ] }, { "elementType": "labels.icon", "stylers": [ { "visibility": "off" } ] }, { "featureType": "transit", "elementType": "geometry", "stylers": [ { "color": "#f2f2f2" }, { "lightness": 19 } ] }, { "featureType": "administrative", "elementType": "geometry.fill", "stylers": [ { "color": "#fefefe" }, { "lightness": 20 } ] }, { "featureType": "administrative", "elementType": "geometry.stroke", "stylers": [ { "color": "#fefefe" }, { "lightness": 17 }, { "weight": 1.2 } ] } ] },
      { name: 'dark', styles: [ { "featureType": "all", "elementType": "labels.text.fill", "stylers": [ { "saturation": 36 }, { "color": "#000000" }, { "lightness": 40 } ] }, { "featureType": "all", "elementType": "labels.text.stroke", "stylers": [ { "visibility": "on" }, { "color": "#000000" }, { "lightness": 16 } ] }, { "featureType": "all", "elementType": "labels.icon", "stylers": [ { "visibility": "off" } ] }, { "featureType": "administrative", "elementType": "geometry.fill", "stylers": [ { "color": "#000000" }, { "lightness": 20 } ] }, { "featureType": "administrative", "elementType": "geometry.stroke", "stylers": [ { "color": "#000000" }, { "lightness": 17 }, { "weight": 1.2 } ] }, { "featureType": "landscape", "elementType": "geometry", "stylers": [ { "color": "#000000" }, { "lightness": 20 } ] }, { "featureType": "poi", "elementType": "geometry", "stylers": [ { "color": "#000000" }, { "lightness": 21 } ] }, { "featureType": "road.highway", "elementType": "geometry.fill", "stylers": [ { "color": "#000000" }, { "lightness": 17 } ] }, { "featureType": "road.highway", "elementType": "geometry.stroke", "stylers": [ { "color": "#000000" }, { "lightness": 29 }, { "weight": 0.2 } ] }, { "featureType": "road.arterial", "elementType": "geometry", "stylers": [ { "color": "#000000" }, { "lightness": 18 } ] }, { "featureType": "road.local", "elementType": "geometry", "stylers": [ { "color": "#000000" }, { "lightness": 16 } ] }, { "featureType": "transit", "elementType": "geometry", "stylers": [ { "color": "#000000" }, { "lightness": 19 } ] }, { "featureType": "water", "elementType": "geometry", "stylers": [ { "color": "#000000" }, { "lightness": 17 } ] } ] },
      { name: 'normalNoLabels', styles: [{ "featureType": "all", "elementType": "labels.text", "stylers": [ { "visibility": "off" } ] }, { "featureType": "all", "elementType": "labels.text.stroke", "stylers": [ { "visibility": "off" } ] }, { "featureType": "landscape", "elementType": "all", "stylers": [ { "color": "#f9f5ed" } ] }, { "featureType": "road.highway", "elementType": "all", "stylers": [ { "color": "#f5f5f5" } ] }, { "featureType": "road.highway", "elementType": "geometry.stroke", "stylers": [ { "color": "#c9c9c9" } ] }, { "featureType": "water", "elementType": "all", "stylers": [ { "color": "#aee0f4" } ] }] },
      { name: 'lightNoLabels', styles: [{ "featureType": "all", "elementType": "labels.text", "stylers": [ { "visibility": "off" } ] }, { "featureType": "water", "elementType": "geometry", "stylers": [ { "color": "#e9e9e9" }, { "lightness": 17 } ] }, { "featureType": "landscape", "elementType": "geometry", "stylers": [ { "color": "#f5f5f5" }, { "lightness": 20 } ] }, { "featureType": "road.highway", "elementType": "geometry.fill", "stylers": [ { "color": "#ffffff" }, { "lightness": 17 } ] }, { "featureType": "road.highway", "elementType": "geometry.stroke", "stylers": [ { "color": "#ffffff" }, { "lightness": 29 }, { "weight": 0.2 } ] }, { "featureType": "road.arterial", "elementType": "geometry", "stylers": [ { "color": "#ffffff" }, { "lightness": 18 } ] }, { "featureType": "road.local", "elementType": "geometry", "stylers": [ { "color": "#ffffff" }, { "lightness": 16 } ] }, { "featureType": "poi", "elementType": "geometry", "stylers": [ { "color": "#f5f5f5" }, { "lightness": 21 } ] }, { "featureType": "poi.park", "elementType": "geometry", "stylers": [ { "color": "#dedede" }, { "lightness": 21 } ] }, { "elementType": "labels.text.stroke", "stylers": [ { "visibility": "on" }, { "color": "#ffffff" }, { "lightness": 16 } ] }, { "elementType": "labels.text.fill", "stylers": [ { "saturation": 36 }, { "color": "#333333" }, { "lightness": 40 } ] }, { "elementType": "labels.icon", "stylers": [ { "visibility": "off" } ] }, { "featureType": "transit", "elementType": "geometry", "stylers": [ { "color": "#f2f2f2" }, { "lightness": 19 } ] }, { "featureType": "administrative", "elementType": "geometry.fill", "stylers": [ { "color": "#fefefe" }, { "lightness": 20 } ] }, { "featureType": "administrative", "elementType": "geometry.stroke", "stylers": [ { "color": "#fefefe" }, { "lightness": 17 }, { "weight": 1.2 } ] } ] },
      { name: 'darkNoLabels', styles: [ { "featureType": "all", "elementType": "labels.text", "stylers": [ { "visibility": "off" } ] }, { "featureType": "all", "elementType": "labels.icon", "stylers": [ { "visibility": "off" } ] }, { "featureType": "administrative", "elementType": "geometry.fill", "stylers": [ { "color": "#000000" }, { "lightness": 20 } ] }, { "featureType": "administrative", "elementType": "geometry.stroke", "stylers": [ { "color": "#000000" }, { "lightness": 17 }, { "weight": 1.2 } ] }, { "featureType": "landscape", "elementType": "geometry", "stylers": [ { "color": "#000000" }, { "lightness": 20 } ] }, { "featureType": "poi", "elementType": "geometry", "stylers": [ { "color": "#000000" }, { "lightness": 21 } ] }, { "featureType": "road.highway", "elementType": "geometry.fill", "stylers": [ { "color": "#000000" }, { "lightness": 17 } ] }, { "featureType": "road.highway", "elementType": "geometry.stroke", "stylers": [ { "color": "#000000" }, { "lightness": 29 }, { "weight": 0.2 } ] }, { "featureType": "road.arterial", "elementType": "geometry", "stylers": [ { "color": "#000000" }, { "lightness": 18 } ] }, { "featureType": "road.local", "elementType": "geometry", "stylers": [ { "color": "#000000" }, { "lightness": 16 } ] }, { "featureType": "transit", "elementType": "geometry", "stylers": [ { "color": "#000000" }, { "lightness": 19 } ] }, { "featureType": "water", "elementType": "geometry", "stylers": [ { "color": "#000000" }, { "lightness": 17 } ] } ] }
    ];
  }else{
    var styles = [
      { name: 'normal', url: 'https://basemaps.cartocdn.com/gl/voyager-gl-style/style.json' },
      { name: 'light', url: 'https://basemaps.cartocdn.com/gl/positron-gl-style/style.json' },
      { name: 'dark', url: 'https://basemaps.cartocdn.com/gl/dark-matter-gl-style/style.json' },
      { name: 'normalNoLabels', url: 'https://basemaps.cartocdn.com/gl/voyager-nolabels-gl-style/style.json' },
      { name: 'lightNoLabels', url: 'https://basemaps.cartocdn.com/gl/positron-nolabels-gl-style/style.json' },
      { name: 'darkNoLabels', url: 'https://basemaps.cartocdn.com/gl/dark-matter-nolabels-gl-style/style.json' }
    ];
  }

  var instances = [];

  const init = () => {
    var mapInitEvent = new Event("prodigy:maps:init");
    var mapSections = document.querySelectorAll(selectors.mapSections);

    if(mapsProvider === 'google'){
      theme.utils.ensureGoogleLoaded().then(() => {
        if(window.maps.api_key === undefined){
          console.warn('Google Maps API Key is undefined');
          return;
        }

        if(mapSections.length > 0){
          theme.utils.getScript(`https://maps.googleapis.com/maps/api/js?key=${window.maps.api_key}`).then(() => {
            window.dispatchEvent(mapInitEvent);
            mapSections.forEach((map) => {
              createMap(map);
            })
          });
        }else{
          window.dispatchEvent(mapInitEvent);
        }
      });
    }else{
      if(mapSections.length > 0){
        theme.utils.getScript(`https://unpkg.com/maplibre-gl@^4.7.1/dist/maplibre-gl.js`).then(() => {
          window.dispatchEvent(mapInitEvent);
          mapSections.forEach((map) => {
            createMap(map);
          });
        })
      }else{
        window.dispatchEvent(mapInitEvent);
      }
    }
  }

  const createMap = async (el) => {
    let parent = el.closest('.section.section__map');

    if(!parent){
      parent = el.closest('[data-block-type="map"]');
    }

    let markerData;

    if(parent.querySelector('.markerData')){
      markerData = JSON.parse(parent.querySelector('.markerData').textContent);
    }else{
      // it's a theme block, get the marker data from the block itself
      const markers = parent.querySelectorAll('.marker-blocks .marker');
      markerData = [];
      
      markers.forEach(m => {
        markerData.push({
          lat: parseFloat(m.dataset.latitude),
          lng: parseFloat(m.dataset.longitude),
          markerContent: m.innerHTML.trim() === '' ? undefined : m.innerHTML.trim(),
          markerColor: m.dataset.markerColor || '#ff0000'
        });        
      })
    }

    if(Shopify.designMode){
      let currMapInstance = await initMap(el);

      markerData.forEach((marker, index) => {
        let interval = 1000 + (index * 300);
        if(mapsProvider !== 'google'){
          interval = 0;
        }

        setTimeout(() => {
          addMarker(currMapInstance.map, currMapInstance.details, marker);
        }, interval);
      });
    }else{
      const observer = new IntersectionObserver(async (entries, observer) => {
        var isIntersecting = typeof entries[0].isIntersecting === 'boolean' ? entries[0].isIntersecting : entries[0].intersectionRatio > 0
        if(isIntersecting){
          let currMapInstance = await initMap(el);
          observer.unobserve(el);

          markerData.forEach((marker, index) => {
            let interval = 1000 + (index * 300);
            if(mapsProvider !== 'google'){
              interval = 0;
            }
            setTimeout(() => {
              addMarker(currMapInstance.map, currMapInstance.details, marker);
            }, interval);
          });
        }
      });

      observer.observe(el);
    }
  }

  const initMap = async (el) => {
    const details = getMapDetails(el);
    const { id, lat, lng, zoom, mobileZoom, style } = details;

    let responsiveZoom = zoom;

    if (window.matchMedia('(max-width: 990px)').matches) {
      responsiveZoom = mobileZoom;
    }

    var instance = {
      id,
      details
    }

    if(mapsProvider === 'google'){
      const { Map } = await google.maps.importLibrary("maps");
      instance.map = new Map(el, {
        center: { lat, lng },
        zoom: responsiveZoom,
        streetViewControl: false,
        fullscreenControl: false,
        mapTypeControl: false,
        controlSize: 20,
        styles: theme.maps.styles.find(s => s.name === style).styles
      });
    }else{
      instance.map = new maplibregl.Map({
        style: theme.maps.styles.find(s => s.name === style).url,
        center: [lng, lat],
        zoom: responsiveZoom,
        container: el,
        attributionControl: false,
        cooperativeGestures: true
      });

      instance.map.addControl(new maplibregl.NavigationControl());
    }

    if(instances.find(i => i.id === instance.id)){
      instances[instance.id] = instance;
    }else{
      instances.push(instance);
    }

    return instance;
  }

  const getMapDetails = (el) => {
    let id = el.getAttribute('id');

    return {
      el,
      id,
      lat: parseFloat(el.dataset.lat),
      lng: parseFloat(el.dataset.long),
      zoom: parseInt(el.dataset.zoom),
      mobileZoom: parseInt(el.dataset.mobileZoom),
      style: el.dataset.style,
      markerPath: window.getComputedStyle(document.documentElement).getPropertyValue('--map-marker'),
      markerWidth: parseFloat( window.getComputedStyle(document.documentElement).getPropertyValue('--map-marker--width') ),
      markerHeight: parseFloat( window.getComputedStyle(document.documentElement).getPropertyValue('--map-marker--height') )
    }
  }

  const addMarker = async (map, details, markerData) => {
    const { markerPath, markerWidth, markerHeight } = details;
    const { lat, lng, markerContent, markerColor } = markerData;

    if(mapsProvider === 'google'){
      const marker = new google.maps.Marker({
        map,
        position: { lat: parseFloat(lat), lng: parseFloat(lng) },
        animation: google.maps.Animation.DROP,
        icon: {
          path: markerPath,
          fillColor: 'transparent',
          fillOpacity: 1,
          anchor: new google.maps.Point(
            markerWidth / 2, // width
            markerHeight // height
          ),
          strokeWeight: 0,
          rotation: 0,
          scale: 1.6
        }
      });

      // fix flickering bug
      // https://issuetracker.google.com/issues/35820791
      setTimeout(() => {
        var icon = marker.getIcon(); // get icon
        icon.fillColor = markerColor; // change its color
        marker.setIcon(icon); // set it back on the marker
      }, 150);

      if(markerContent !== undefined){
        const infoWindow = new google.maps.InfoWindow({
          content: markerContent
        });

        marker.addListener("click", () => {
          infoWindow.open({
            anchor: marker,
            map,
          });
        });
      }
    }else{
      var icon = document.createElement('div');
      icon.classList.add("map-marker");
      icon.style.backgroundColor = markerColor;

      const marker = new maplibregl.Marker({
        element: icon
      }).setLngLat([lng, lat])

      if(markerContent !== undefined){
        var popup = new maplibregl.Popup({
          anchor: 'bottom',
          offset: [0, -20] // height - shadow
        })
        .setHTML(markerContent);

        marker
          .setPopup(popup)
          .addClassName('has-popup');
      }

      marker.addTo(map);
    }
  }

  return {
    init,
    createMap,
    addMarker,
    getMapDetails,
    initMap,
    instances: instances,
    styles: styles
  }
})();

theme.mobileMenu = (function(){
  var selectors = {
    icon: '.header__icon--menu',
    section: '.section__mobile-menu-drawer',
    drawer: 'header-drawer.drawer',
    header: '.section__header',
    drawerOverlay: '.drawer__overlay',
    trigger: '[data-mobile-menu-open]',
    closeTrigger: '[data-mobile-menu-close]'
  }

  var section = document.querySelector(selectors.section);
  let activeElement = '';

  const setActiveElement = (element) => {
    activeElement = element;
  }

  const open = (triggeredBy) => {
    if (triggeredBy) setActiveElement(triggeredBy);

    setTimeout(() => {
      let drawer = document.querySelector(selectors.drawer);
      drawer.classList.add('animate', 'active');
    });

    let drawer = document.querySelector(selectors.drawer);

    drawer.addEventListener('transitionend', () => {
      const containerToTrapFocusOn = drawer.classList.contains('is-empty') ? drawer.querySelector('.drawer__inner-empty') : document.querySelector(selectors.drawer);
      const focusElement = drawer.querySelector('.drawer__inner') || drawer.querySelector('.drawer__close');
      trapFocus(containerToTrapFocusOn, focusElement);      
    }, { once: true });

    document.body.classList.add('overflow-hidden');
    document.body.classList.add('header-drawer--open');

    window.dispatchEvent(new CustomEvent('prodigy:menu-drawer:opened'))
  }

  const close = () => {
    let drawer = document.querySelector(selectors.drawer);
    drawer.classList.remove('active');
    theme.utils.removeTrapFocus(activeElement);
    document.body.classList.remove('overflow-hidden');
    document.body.classList.remove('header-drawer--open');

    window.dispatchEvent(new CustomEvent('prodigy:menu-drawer:closed'))
  }

  const setupTriggers = () => {
    let openTriggers = document.querySelectorAll(selectors.trigger);
    openTriggers.forEach(trigger => {
      trigger.addEventListener('click', () => open(trigger));
    });

    let closeTriggers = document.querySelectorAll(selectors.closeTrigger);    
    closeTriggers.forEach(trigger => {
      trigger.addEventListener('click', close);
    });
  }
  
  const bindEvents = () => {   
    let drawer = document.querySelector(selectors.drawer);

    if(section){
      section.querySelectorAll('button:not(.localization-selector)').forEach((button) =>
        button.addEventListener('click', onCloseButtonClick)
      );
    }

    if(drawer){
      drawer.querySelector(selectors.drawerOverlay).addEventListener('click', close);
      drawer.addEventListener('keyup', (evt) => evt.code === 'Escape' && close());
    }

    if (window.matchMedia('(max-width: 990px)').matches) {
      document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
    }
  }

  const onCloseButtonClick = (event) => {    
    const detailsElement = event.currentTarget.closest('details');
    closeSubmenu(detailsElement);
  }

  const closeSubmenu = (detailsElement) => {
    const parentMenuElement = detailsElement.closest('.submenu-open');
    parentMenuElement && parentMenuElement.classList.remove('submenu-open');
    detailsElement.classList.remove('menu-opening');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    theme.utils.removeTrapFocus(detailsElement.querySelector('summary'));
    closeAnimation(detailsElement);
  }

  const closeAnimation = (detailsElement) => {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    }

    window.requestAnimationFrame(handleAnimation);
  }

  const init = () => {
    bindEvents();
    setupTriggers();
  }

  return {
    init,
    open,
    close,
    selectors
  }
})();

theme.modals = (function(){
  var selectors = {
    close: 'button[data-modal-close]',
    modalOverlay: '.modal__overlay[data-modal-close]',
    videoModalTrigger: '[data-video-modal-trigger]',
    productBlockModalTrigger: '[data-product-block-modal-trigger]',
    productGalleryModalTrigger: '[data-product-gallery-modal-trigger]',
    quickView: {
      modalTrigger: '[data-quick-view-modal-trigger]',
      sectionId: 'quick-view-modal',
      sectionClass: '.section__quick-view-modal'
    },
    upsell: {
      modalTrigger: '[data-upsell-modal-trigger]',
      modalId: 'upsell-modal'
    },
    popup: {
      section: '.section.section__popup',
      modalWrapper: '.modal__wrapper'
    }
  }

  const defaultOptions = {
    awaitOpenAnimation: true,
    awaitCloseAnimation: true,
    disableFocus: true,
    disableScroll: true,
    onClose: modal => {
      window.dispatchEvent(new CustomEvent('prodigy:modal:closed', {
        detail: {
          modalId: modal.id,
          modal
        }
      }));
    }
  };

  const playModalMedia = (modal) => {
    let modalVideo = modal.querySelector('video');
    if(modalVideo){
      modalVideo.play();
    }else{
      let modalIframe = modal.querySelector('iframe');
      if(modalIframe.src === '' || modalIframe.src === undefined){
        modalIframe.src = modalIframe.dataset.src;
      }
    }
  }

  const initPopups = () => {
    let popups = document.querySelectorAll(selectors.popup.section);

    if(popups){
      popups.forEach(popup => {
        if(popup.querySelector(selectors.popup.modalWrapper)){
          initPopup(popup);
        }
      });
    }
  }

  const initCustomModals = () => {
    let modalButtons = document.querySelectorAll('[data-prodigy-modal-trigger]');

    if(modalButtons){
      modalButtons.forEach(button => {
        button.addEventListener('click', function(){
          open('password-modal');
        });
      });
    }

  }

  const initPopup = (popup) => {
    let wrapper = popup.querySelector(selectors.popup.modalWrapper);
    let modalId = wrapper.dataset.modalId;
    let popupWrapper = wrapper.querySelector(`.${modalId}__wrapper`);
    let enableCookie = popupWrapper.hasAttribute('data-cookie-enabled');
    let cookieDuration = parseInt(popupWrapper.dataset.cookieDuration);
    let delayBehavior = popupWrapper.dataset.delayBehavior;
    let popupCookie = theme.cookies.get(`prodigy:${modalId}`);
    let threshold;


    if(document.querySelector(`#${modalId} #cancel_button`)){
      document.querySelector(`#${modalId} #cancel_button`).addEventListener('click', function(){
        theme.modals.close(`${modalId}`);
        if(enableCookie){
          theme.cookies.set(`prodigy:${modalId}`, true, cookieDuration);
        }
      });
    }


    if(!popupCookie && !Shopify.designMode){
      switch (delayBehavior) {
        case 'seconds':
          let delay = popupWrapper.dataset.delay * 1000;
          showPopup({
            hasDelay: true,
            delay,
            enableCookie,
            cookieDuration,
            modalId
          });
          break;
        case 'idle':
          theme.utils.initIdleTimer();
          window.addEventListener('prodigy:idle-timer:updated', function eventHandler(e){
            if(e.detail.elapsed === 60){
              showPopup({
                enableCookie,
                cookieDuration,
                modalId
              });
              window.removeEventListener('prodigy:idle-timer:updated', eventHandler);
            }
          });
          break;
        case 'scroll_half':
          threshold = 50;
          break;
        case 'scroll_bottom':
          threshold = 100;
          break;
      }

      if(delayBehavior.startsWith('scroll_')){
        window.addEventListener('prodigy:scroll', function scrollHandler(e){
          if(e.detail.percentage >= threshold){
            showPopup({
              cookieDuration,
              enableCookie,
              modalId
            });
            window.removeEventListener('prodigy:scroll', scrollHandler);
          }
        });
      }

      if(delayBehavior === 'manual'){
        MicroModal.init({
          openTrigger: 'data-prodigy-modal-trigger',
          ...theme.modals.defaultOptions
        });
      }
    }
  }

  const showPopup = ({
    hasDelay = false,
    delay = 0,
    enableCookie = true,
    cookieDuration = 30,
    modalId = ''
  } = {}) => {
    let microModalSettings = {
      openTrigger: 'data-custom-open',
      openClass: 'is-open',
      disableScroll: true,
      disableFocus: true,
      awaitOpenAnimation: true,
      awaitCloseAnimation: true,
      onClose: modal => {
        if(enableCookie){
          theme.cookies.set(`prodigy:${modalId}`, true, cookieDuration);
        }

        const popupClosed = new CustomEvent('prodigy:popup:closed', {
          detail: {
            modal
          }
        });

        window.dispatchEvent( popupClosed );
      },
      onShow: modal => {
        const popupOpened = new CustomEvent('prodigy:popup:opened', {
          detail: {
            modal
          }
        });

        window.dispatchEvent( popupOpened );
      }
    };

    // if the form has posted
    if(window.location.search.indexOf("?customer_posted=true") !== -1){
      delay = 0;
      theme.cookies.set(`prodigy:${modalId}`, true, cookieDuration);
    }

    if(hasDelay){
      setTimeout(function(){
        MicroModal.show(modalId, microModalSettings);
      }, delay);
    }else{
      MicroModal.show(modalId, microModalSettings);
    }
  }

  const initVideoModals = () => {
    let modalButtons = document.querySelectorAll(selectors.videoModalTrigger);

    modalButtons.forEach(modalButton => modalButton.addEventListener('click', function(e){
      e.preventDefault();
      let modal = e.target.closest(selectors.videoModalTrigger);
      let modalId = modal.dataset.modalId;

      window.dispatchEvent(new CustomEvent('prodigy:modal:clicked', {
        detail: {
          modalId,
          modal
        }
      }));

      open(modalId, {
        onShow: modal => {
          playModalMedia(modal);
        },
        onClose: modal => {
          theme.utils.pauseAllMedia(modal);
        }
      });
    }));
  }

  const initProductBlockModals = () => {
    let modalButtons = document.querySelectorAll(selectors.productBlockModalTrigger);

    modalButtons.forEach(modalButton => modalButton.addEventListener('click', function(e){
      e.preventDefault();
      let modal = e.target.closest(selectors.productBlockModalTrigger);
      let modalId = modal.dataset.modalId;

      window.dispatchEvent(new CustomEvent('prodigy:modal:clicked', {
        detail: {
          modalId,
          modal
        }
      }));

      open(modalId);
    }));
  }

  const showActiveMedia = (modalId, mediaId) => {
    let galleryModal = document.getElementById(modalId);

    galleryModal.querySelectorAll(`[data-media-id]:not([data-media-id="${mediaId}"])`).forEach((element) => {
        element.classList.remove('active');
      }
    )
    const activeMedia = galleryModal.querySelector(`[data-media-id="${mediaId}"]`);
    const activeMediaTemplate = activeMedia.querySelector('template');
    const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
    activeMedia.classList.add('active');
    activeMedia.scrollIntoView();

    const container = galleryModal.querySelector('[role="document"]');
    container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

    if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
      activeMedia.loadContent();
  }

  const initProductGalleryModals = () => {
    let modalButtons = document.querySelectorAll(selectors.productGalleryModalTrigger);

    modalButtons.forEach(modalButton => modalButton.addEventListener('click', function(e){
      e.preventDefault();
      let modal = e.target.closest(selectors.productGalleryModalTrigger);
      let modalOpener = modal.querySelector('.product__media-toggle[data-media-id]');
      let mediaId = modalOpener.dataset.mediaId;
      let modalId = modal.dataset.modalId;

      window.dispatchEvent(new CustomEvent('prodigy:modal:clicked', {
        detail: {
          modalId,
          modal
        }
      }));

      open(modalId, {
        onShow: modal => {
          showActiveMedia(modalId, mediaId);
        }
      });
    }));
  }

  const initQuickViewModals = () => {
    if( document.querySelectorAll(selectors.quickView.modalTrigger).length > 0 ){
      let quickViewButtons = document.querySelectorAll(selectors.quickView.modalTrigger);
      let sectionId = document.querySelector(selectors.quickView.sectionClass).id.replace('shopify-section-', '');

      quickViewButtons.forEach(button => button.addEventListener('click', function(e){
        e.preventDefault();
  
        fetch(`${Shopify.routes.root}products/${button.dataset.productHandle}?sections=${sectionId}`).then(response => response.json())
          .then((response) => {
            let sectionEl = document.getElementById(`shopify-section-${sectionId}`);
            if(sectionEl){
              sectionEl.innerHTML = theme.utils.getSectionInnerHTML(response[sectionId], selectors.quickView.sectionClass);
            }else{
              let sectionHTML = new DOMParser().parseFromString(response[sectionId], 'text/html').getRootNode().body;
              document.body.appendChild( sectionHTML );
            }
  
            theme.modals.closeButtonListeners();
            theme.sliders.initProductSliders();
            theme.products.init();
            if(window.theme.settings.wishlistEnabled) theme.wishlist.close();
            setTimeout(() => { theme.modals.open(theme.modals.selectors.quickView.sectionId); }, 100);
          });
      }));
    }
  }

  const upsellModalListener = () => {
    window.addEventListener('prodigy:modal:closed', (e) => {
      if(e.detail.modalId == theme.modals.selectors.upsell.modalId){
        let modal = e.detail.modal;
        let upsellWrapper = modal.querySelector('.upsell-list__wrapper');

        if(upsellWrapper.hasAttribute('data-cookie-enabled')){
          theme.cookies.set('prodigy:upsell-modal-viewed', true, parseInt(upsellWrapper.dataset.cookieDuration));
        }

        setTimeout(() => {
          let cart = document.querySelector('cart-drawer');
          if(cart) cart.open();
        }, theme.durations.medium);
      }
    });
  }

  const open = (id, options = {}) => {
    const customOptions = {
      ...defaultOptions,
      ...options
    };

    MicroModal.show(id, customOptions);
    window.dispatchEvent(new CustomEvent('prodigy:modal:opened', {
      detail: {
        modal: document.querySelector(`[data-modal-id="${id}"]`),
        modalId: id,
        options: customOptions
      }
    }));
  }

  const close = (id, options) => {
    const customOptions = {
      ...defaultOptions,
      ...options
    };

    MicroModal.close(id, customOptions);
    window.dispatchEvent(new CustomEvent('prodigy:modal:closed', {
      detail: {
        modalId: id,
        modal: document.querySelector(`[data-modal-id="${id}"]`),
        options: customOptions
      }
    }));
  }

  // listen for modal triggers
  const addEventListeners = () => {
    window.addEventListener('prodigy:modal:open', (e) => {
      let options = {},
          modalId = e.detail.id;

      if(e.detail.options !== undefined) options = e.detail.options;
      if(document.getElementById(modalId)) open(modalId, options);
    });

    window.addEventListener('prodigy:modal:close', (e) => {
      let options = {},
          modalId = e.detail.id;

      if(e.detail.options !== undefined) options = e.detail.options;
      if(document.getElementById(modalId)) close(modalId, options);
    });

    window.addEventListener('prodigy:product-recommendations:init', function(){
      initQuickViewModals();
    });

    window.addEventListener('prodigy:wishlist-drawer:loaded', function(){
      initQuickViewModals();
    });
  }

  const closeButtonListeners = () => {
    let closeButtons = document.querySelectorAll(selectors.close);
    let modalOverlays = document.querySelectorAll(selectors.modalOverlay);

    closeButtons.forEach(button => {
      button.addEventListener('click', function(){
        close(button.closest('.modal').dataset.modalId);
      })
    });

    modalOverlays.forEach(overlay => {
      overlay.addEventListener('click', function(e){
        if(e.target !== e.currentTarget) return;
        close(overlay.closest('.modal').dataset.modalId);
      })
    });
  }

  const init = () => {
    initPopups();
    initCustomModals();
    initProductGalleryModals();
    initProductBlockModals();
    initVideoModals();
    initQuickViewModals();
    upsellModalListener();
    addEventListeners();
    closeButtonListeners();
  }

  return {
    init,
    open,
    close,
    playModalMedia,
    initProductBlockModals,
    initProductGalleryModals,
    initVideoModals,
    initQuickViewModals,
    addEventListeners,
    closeButtonListeners,
    defaultOptions,
    selectors
  }
})();

theme.navigation = (function(){
  var selectors = {
    navWrapper: '.desktop-nav__wrapper[data-click]',
    megaMenuWrapper: '.mega-menu__wrapper',
    megaMenu: '.mega-menu',
    dropdownWrapper: '.header-menu',
    dropdown: '.header-menu__dropdown',
    menuItem: '.header__menu-item',
    megaMenuOpenClass: 'open',
    dropdownOpenClass: 'open'
  };

  const init = () => {
    clickMegaMenus();
    clickDropdowns();
  }

  const clickMegaMenus = () => {
    let megaMenus = document.querySelectorAll(`${selectors.navWrapper} ${selectors.megaMenuWrapper}`);

    megaMenus.forEach(m => {
      m.addEventListener('click', toggleMegaMenu);
    })
  }

  const toggleMegaMenu = (e) => {
    e.preventDefault();

    let currentMenu = e.target.closest(selectors.megaMenu);
    let megaMenus = document.querySelectorAll(`${selectors.navWrapper} ${selectors.megaMenuWrapper} ${selectors.megaMenu}`);

    // open clicked mega menu
    currentMenu.classList.toggle(selectors.megaMenuOpenClass);
    // close all open mega menus
    megaMenus.forEach(m => {
      if(m !== currentMenu) m.classList.remove(selectors.megaMenuOpenClass)
    });
  }

  const clickDropdowns = () => {
    let dropdowns = document.querySelectorAll(`${selectors.navWrapper} ${selectors.dropdownWrapper} ${selectors.dropdown} > div, [data-block-type='icon_account'][data-click] ${selectors.dropdownWrapper} ${selectors.dropdown} > div`);

    dropdowns.forEach(d => {
      d.addEventListener('click', toggleDropdown);
      d.addEventListener('keyup', (evt) => {
        evt.key === 'Enter' && toggleDropdown(evt)
        evt.key === 'Escape' && toggleDropdown(evt)    
      });
    })
  }

  const toggleDropdown = (e) => {
    if(e.target.nodeName === 'SUMMARY' || e.target.parentElement.nodeName === 'SUMMARY') return;
    e.preventDefault();

    let currentDropdown = e.target.closest(selectors.dropdown);
    let dropdowns = document.querySelectorAll(`${selectors.navWrapper} ${selectors.dropdownWrapper} ${selectors.dropdown} > div, [data-block-type='icon_account'][data-click] ${selectors.dropdownWrapper} ${selectors.dropdown} > div`);

    // open clicked dropdown
    currentDropdown.classList.toggle(selectors.dropdownOpenClass);
    // close all open dropdowns
    dropdowns.forEach(d => {
      if(d !== currentDropdown) d.classList.remove(selectors.dropdownOpenClass)
    });
  }

  return {
    init: init
  }
})();

theme.products = (function(){
  const selectors = {
    alt: {
      info: '.alt-info',
      zoom: '.alt-info--zoom'
    },
    open: '.open',
    product: {
      image: '.product__media'
    }
  }

  const altInfo = () => {
    document.querySelectorAll(selectors.alt.info).forEach(el => el.addEventListener('click', function(){
      el.classList.toggle(selectors.open.replace('.',''));
    }));
  }

  const init = () => {
    altInfo();
    productMediaZoom();

    let productForms = document.querySelectorAll('.product-form');

    productForms.forEach(productForm => {
      if(productForm.closest('.product') !== null){
        if(productForm.closest('.product').dataset.updateUrl === 'false') preventVariantURLSwitching(productForm);
      }

      let form = productForm.querySelector('form');

      if(form){
        form.querySelector('[name=id]').disabled = false;
        form.addEventListener('submit', e => {
          onSubmitHandler(e, productForm);
        });
      }
    })
  }

  const zoom = (e) => {
    var zoomEl = e.currentTarget;
    e.offsetX ? offsetX = e.offsetX : offsetX = e.touches[0].pageX
    e.offsetY ? offsetY = e.offsetY : offsetX = e.touches[0].pageX
    x = offsetX/zoomEl.offsetWidth * 100
    y = offsetY/zoomEl.offsetHeight * 100
    zoomEl.style.backgroundPosition = x + '% ' + y + '%';
  }

  const productMediaZoom = () => {
    document.querySelectorAll(`${selectors.product.image}[data-zoom-type='hover']`).forEach(image => {
      image.addEventListener('click', function(e){
        image.classList.toggle('zoom-active');
        image.addEventListener('mousemove', function(e){
          zoom(e);
        });
      });
    })
  }

  const preventVariantURLSwitching = (productForm) => {
    let selectors = productForm.closest('.product').querySelector('variant-radios,variant-selects');
    if(selectors) selectors.setAttribute('data-update-url', 'false');
  }

  const onSubmitHandler = (evt, productForm) => {
    evt.preventDefault();

    let submitButton = productForm.querySelector('[type="submit"]');
    let inModal = false;
    let inWishlist = false;
    let error = false;
    let modal = null;
    let form = productForm.querySelector('form');
    let hasUpsell = submitButton.hasAttribute('data-upsell-modal-trigger');

    if (submitButton.getAttribute('aria-disabled') === 'true') return;
    form.querySelector('[name=id]').disabled = false;

    if( form.closest('.modal') !== null ){
      inModal = true;
      modal = form.closest('.modal');
    }

    if( form.closest(theme.wishlist.selectors.drawer) !== null ){
      inWishlist = true;
    }

    let cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
    theme.products.handleErrorMessage({
      section: productForm,
      errorMessage: error
    });

    theme.utils.setButtonLoading(submitButton);

    const config = theme.utils.fetchConfig('javascript');
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    delete config.headers['Content-Type'];

    const formData = new FormData(form);
    if (cart) {
      formData.append('sections', cart.getSectionsToRender().map((section) => section.id));
      formData.append('sections_url', window.location.pathname);
      cart.setActiveElement(document.activeElement);
    }
    config.body = formData;

    // parse form / variant data for custom events
    const parsedForm = {};
    formData.forEach((v,k) => parsedForm[k] = v);
    let quantity = 1;

    if(parsedForm['quantity']){
      quantity = parsedForm['quantity'];
    }

    const detail = {
      productId: parseInt(parsedForm['product-id']),
      quantity: parseInt(quantity),
    };

    const variantJSON = document.querySelectorAll(`.variantJSON[data-product-id="${parsedForm['product-id']}"]`);

    if(variantJSON.length > 0){
      detail.variant = JSON.parse(variantJSON[0].textContent).filter(v => v.id === parseInt(parsedForm['id']))[0]
    }else{
      detail.variantId = parseInt(parsedForm['id']);
    }

    window.dispatchEvent(new CustomEvent('prodigy:add-to-cart:clicked', {
      detail
    }));

    // add to cart
    fetch(`${routes.cart_add_url}`, config)
      .then((response) => response.json())
      .then((response) => {
        if (response.status) {
          theme.products.handleErrorMessage({
            section: productForm,
            errorMessage: response.description
          });

          window.dispatchEvent(new CustomEvent('prodigy:add-to-cart:error', {
            detail: {
              ...detail,
              response
            }
          }));

          const soldOutMessage = submitButton.querySelector('.sold-out-message');
          if (!soldOutMessage) return;
          submitButton.setAttribute('aria-disabled', true);
          submitButton.querySelector('span').classList.add('hidden');
          soldOutMessage.classList.remove('hidden');
          error = true;
          return;
        }else{
          let showCart = true;
          let upsellModalCookie = theme.cookies.get('prodigy:upsell-modal-viewed');

          if( submitButton.hasAttribute('data-suppress-cart') || (hasUpsell && !upsellModalCookie) || inModal ){
            showCart = false;
          }

          cart.renderContents(response, showCart);

          window.dispatchEvent(new CustomEvent('prodigy:add-to-cart:success', {
            detail: {
              ...detail,
              response
            }
          }));

          if( hasUpsell && !upsellModalCookie ){
            theme.modals.open(theme.modals.selectors.upsell.modalId);
          }
        }

        if(inModal || hasUpsell){
          window.addEventListener('prodigy:modal:closed', (e) => {
            setTimeout(() => {
              cart.open();
            }, theme.durations.medium);
          });

          if(inModal) theme.modals.close(modal.dataset.modalId);
        }

        if(inWishlist){
          theme.wishlist.close();
        }

        if (!cart) {
          window.location = window.routes.cart_url;
          return;
        }
      })
      .catch((e) => {
        console.error(e);
      })
      .finally(() => {
        submitButton.classList.remove('loading');
        if (cart && cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
        if (!error) submitButton.removeAttribute('aria-disabled');
        productForm.querySelector('.loading-overlay__spinner').classList.add('hidden');
      });
  }

  const handleErrorMessage = ({
    section = document,
    errorMessage = false
  }) => {
    if(typeof errorMessage === 'object'){
      for (var prop in errorMessage) {
        errorMessage = errorMessage[prop][0];
        break;
      }
    }

    let errorMessageWrapper = section.querySelector('.product-form__error-message-wrapper');
    if (!errorMessageWrapper) return;
    let errorMessageEl = errorMessageWrapper.querySelector('.product-form__error-message');
    if (!errorMessageEl) return;

    if (errorMessage) {
      errorMessageEl.textContent = errorMessage;
      errorMessageWrapper.toggleAttribute('hidden');
    }else{
      errorMessageEl.textContent = '';
      errorMessageWrapper.setAttribute('hidden', true);
    }
  }

  return {
    selectors,
    init,
    altInfo,
    productMediaZoom,
    handleErrorMessage,
    onSubmitHandler,
    zoom
  }
})();

theme.priceRange = (function(){
  const selectors = {
    range: '.price-range',
    input: '.price-range__range-input',
    slider: '.price-range__slider',
    progress: '.price-range__progress',
    minInput: `.price-range__min`,
    maxInput: `.price-range__max`
  }
  
  const init = () => {
    let ranges = document.querySelectorAll(selectors.range);

    ranges.forEach(range => {
      initRange(range);
    });

    // add event listener to update slider on facet input changed
    window.addEventListener('prodigy:price-range:input-changed', function(e){
      let detail = e.detail;
      let slider = document.getElementById(detail.sliderId);
      let minInput = slider.querySelector(`${selectors.input} ${selectors.minInput}`);
      let maxInput = slider.querySelector(`${selectors.input} ${selectors.maxInput}`);
      let event = new Event('input', {
        'bubbles': true,
        'cancelable': true
      });

      if(detail.eventType === 'min'){
        minInput.value = detail.minValue;
        minInput.dispatchEvent(event);
      }else{
        maxInput.value = detail.maxValue;
        maxInput.dispatchEvent(event);
      }
    });

    // reload ranges when HTML is updated
    window.addEventListener('prodigy:facet-filters:reloaded', function(){
      reloadRanges();
    });

    window.addEventListener('prodigy:facet-filters:loaded', function(){
      reloadRanges();
    });
  }

  const reloadRanges = () => {
    let ranges = document.querySelectorAll(selectors.range);

    ranges.forEach(range => {
      initRange(range);
    });
  }

  const setRange = (range, eventType) => {
    const rangeInput = range.querySelectorAll(`${selectors.input} input`),
          progress = range.querySelector(`${selectors.slider} ${selectors.progress}`);

    let minInput = rangeInput[0];
    let maxInput = rangeInput[1];
    let priceGap = parseInt(range.dataset.priceGap);

    let minVal = parseInt(minInput.value),
    maxVal = parseInt(maxInput.value);

    if (maxVal - minVal < priceGap) {
      if (eventType === 'min') {
        minInput.value = maxVal - priceGap;
      } else {
        maxInput.value = minVal + priceGap;
      }
      return false;
    } else {
      progress.style.left = (minVal / minInput.max) * 100 + "%";
      progress.style.right = 100 - (maxVal / maxInput.max) * 100 + "%";
    }

    return {
      minVal,
      maxVal
    }
  }

  const initRange = (range) => {
    const rangeInput = range.querySelectorAll(`${selectors.input} input`);

    setRange(range, 'min');

    rangeInput.forEach((input) => {
      input.addEventListener("input", (e) => {
        let eventType = (e.target.className === "price-range__min") ? 'min' : 'max'
        let values = setRange(range, eventType);

        if(values){
          // add event dispatch to update input on slider changed
          window.dispatchEvent(new CustomEvent('prodigy:price-range:range-changed', {
            detail: {
              eventType,
              minVal: values.minVal,
              maxVal: values.maxVal
            }
          }));
        }
      });
    });    
  }

  return {
    init
  }

})();

theme.scrollAnimations = (function(){
  const selectors = {
     class: '[data-scroll-animation]:not([data-scroll-animation-header])',
     headerClass: '[data-scroll-animation-header]',
     onAnimate: 'animate'
  }

  const observer = ({
    threshold = 0.3,
    rootMargin = `0px 0px 0px 0px`
  }) => {
    return new IntersectionObserver((entries, observer) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add(selectors.onAnimate);
          if(window.theme.settings.onlyAnimateOnce) observer.unobserve(entry.target);
        }
        else {
          entry.target.classList.remove(selectors.onAnimate)
        }
      })
    },
    {
      threshold: threshold,
      rootMargin: rootMargin
    });
  }

  const createAnimationObservers = () => {
    let headerHeight = document.querySelector('.header-group').offsetHeight;
    let intersectionObserver = observer({
      rootMargin: `-${headerHeight + 20}px 0px 0px 0px`
    });
    let intersectionObserverHeader = observer({
      rootMargin: `0px 0px 0px 0px`
    });

    let animationEls = document.querySelectorAll(selectors.class);
    animationEls.forEach(el => {
      intersectionObserver.observe(el);
    });

    let animationElsHeader = document.querySelectorAll(selectors.headerClass);
    animationElsHeader.forEach(el => {
      intersectionObserverHeader.observe(el);
    })
  }

  const init = () => {
    if( document.querySelector('.section__announcement-bar') ){
      window.addEventListener('prodigy:announcement:loaded', function(){
        createAnimationObservers();
      })
    }else{
      createAnimationObservers();
    }
  }

  return {
    init,
    observer,
    createAnimationObservers,
    selectors
  }
})();

theme.scrollTop = (function(){
  const selectors = {
    button: '#scroll-top'
  }

  const initClickHandler = () => {
    if(document.querySelector(selectors.button)){
      document.querySelector(selectors.button).addEventListener('click', function(){
        window.scrollTo({top: 0, behavior: 'smooth'});
      });
    }
  }

  const init = () => {
    initClickHandler();
  }

  return {
    init,
    initClickHandler
  }
})();

theme.sliders = (function() {
  var selectors = {
    sliderSections: '[data-slider]',
    productSliderSections: '[data-product-slider]',
    tickerSections: '[data-ticker]',
    productSlider: '.product .media-slider',
    thumbsSlider: '.product .thumbnail-slider',
    sliderContent: '.slider__content',
    tickerContent: '.ticker__content',
    sliderPagination: '.slider__pagination',
    sliderButtonPrev: '.slider__button--prev',
    sliderButtonNext: '.slider__button--next'
  };

  var instances = [];
  var productInstances = [];
  var tickerInstances = [];

  const init = () => {
    initSliders();
    initProductSliders();
    initTickers();
    addListeners();
  }

  const initSliders = () => {
    var sliderSections = document.querySelectorAll(selectors.sliderSections);

    sliderSections.forEach((slider) => {
      initSlider(slider, slider.dataset.sectionId);
    });
  }

  const initProductSliders = () => {
    var productSliderSections = document.querySelectorAll(selectors.productSliderSections);

    productSliderSections.forEach((slider) => {
      initProductSlider(slider, slider.dataset.sectionId);
    });
  }

  const initTickers = () => {
    var tickerSections = document.querySelectorAll(selectors.tickerSections);

    tickerSections.forEach((ticker) => {
      initTicker(ticker, ticker.dataset.sectionId);
    });
  }

  const addListeners = () => {
    window.addEventListener('prodigy:pdp:variant-media-filtered', function(e){      
      let section = e.detail.section;
      let currInstance = productInstances.find(i => i.id === section.dataset.sectionId);

      currInstance.thumbsSlider.destroy(false, false);
      currInstance.productSlider.destroy(false, false);

      window.theme.sliders.initProductSlider(section, section.dataset.sectionId);
      window.theme.sliders.productInstances.find(i => i.id === section.dataset.sectionId).productSlider.update();      
    });

    window.addEventListener('prodigy:pdp:variant-media-updated', function(e){
      let currInstance = productInstances.find(i => i.id === e.detail.sectionId);
      let featuredImageSlide = document.querySelector(`[data-media-id="${e.detail.sectionId}-${e.detail.currentVariant.featured_media.id}"]`);

      if(currInstance.productSlider.destroyed != true){
        if(currInstance.productSlider.params.loop === true){
          currInstance.productSlider.slideToLoop(featuredImageSlide.dataset.swiperSlideIndex, window.theme.durations.default);
        }else{
          let slides = e.detail.section.querySelectorAll('.media-slider .slider__slide');
          let currIndex = [...slides].indexOf(featuredImageSlide);
          currInstance.productSlider.slideTo(currIndex, window.theme.durations.default);
        }
      }
    });
  }

  const destroySliders = () => {
    instances.forEach(i => {
      i.swiper.destroy();
    });
  }

  const destroyTickers = () => {
    tickerInstances.forEach(i => {
      i.ticker.destroy();
    })
  }

  const initSlider = (el, id) => {    
    let sectionId = `[data-section-id="${id}"]`;
    let sliderContent = el.querySelector(selectors.sliderContent);
    let centered = sliderContent.dataset.centered === 'true';
    let loop = sliderContent.dataset.loop === 'true';
    let clickable = sliderContent.dataset.dotsClickable === 'true';
    let autoplayEnabled = sliderContent.dataset.autoplay === 'true';
    let slideCount = parseInt(sliderContent.dataset.slideCount);
    let prevEl = `${sectionId} ${selectors.sliderButtonPrev}`;
    let nextEl = `${sectionId} ${selectors.sliderButtonNext}`;

    if(slideCount <= 1) return;

    if(document.querySelector(sectionId).closest('.cart-drawer-block')){
      let blockId = document.querySelector(sectionId).closest('.cart-drawer-block').dataset.blockId;
      nextEl = `[data-block-id="${blockId}"] ${selectors.sliderButtonNext}`;
      prevEl = `[data-block-id="${blockId}"] ${selectors.sliderButtonPrev}`;
    }

    if(document.querySelector(sectionId).closest('[data-section-type="custom-content"]')){
      let blockId = document.querySelector(sectionId).closest('[data-block-id]').dataset.blockId;
      nextEl = `[data-block-id="${blockId}"] ${selectors.sliderButtonNext}`;
      prevEl = `[data-block-id="${blockId}"] ${selectors.sliderButtonPrev}`;
    }

    let swiperOptions = {
      enabled: el.dataset.sliderMobileEnabled === 'true' || el.dataset.sliderMobileEnabled === undefined,
      loop: loop,
      speed: sliderContent.dataset.speed,
      centeredSlides: centered,
      slidesPerView: sliderContent.dataset.columnsMobile,
      spaceBetween: sliderContent.dataset.spaceBetween,
      direction: sliderContent.dataset.direction,
      autoHeight: sliderContent.dataset.direction === 'vertical',
      grabCursor: true,
      mousewheel: {
        enabled: sliderContent.dataset.mousewheel === 'true',
        forceToAxis: true
      },
      freeMode: sliderContent.dataset.freeMode === 'true',
      navigation: {
        prevEl,
        nextEl
      },
      pagination: {
        type: sliderContent.dataset.paginationType,
        el: `${sectionId} ${selectors.sliderPagination}`,
        clickable: clickable
      },
      breakpoints: {
        768: {
          enabled: el.dataset.sliderTabletEnabled === 'true' || el.dataset.sliderTabletEnabled === undefined,
          slidesPerView: sliderContent.dataset.columnsTablet
        },
        1024: {
          enabled: el.dataset.sliderDesktopEnabled === 'true' || el.dataset.sliderDesktopEnabled === undefined,
          slidesPerView: sliderContent.dataset.columns
        }
      }
    };

    if(slideCount > window.theme.config.maxPagination && sliderContent.dataset.direction === 'horizontal'){
      if(sliderContent.dataset.dynamicBullets === 'true'){
        swiperOptions.pagination.dynamicBullets = true;
      }
    }

    if(autoplayEnabled){
      swiperOptions.autoplay = {
        delay: sliderContent.dataset.autoplayDuration
      }
    }

    if(el.dataset.sliderDesktopEnabled === 'true' || el.dataset.sliderTabletEnabled === 'true' || el.dataset.sliderMobileEnabled === 'true'){
      var instance = {
        id: id,
        swiper: new Swiper(`${sectionId} ${selectors.sliderContent}`, swiperOptions)
      }
  
      if(instances.find(i => i.id === instance.id)){
        instances[instance.id] = instance;
      }else{
        instances.push(instance);
      }
    }
  }

  const initProductSlider = (el, id) => {
    let sectionId = `[data-section-id="${id}"]`;
    let sliderContent = el.querySelector(`${selectors.productSlider} ${selectors.sliderContent}`);

    if(!sliderContent || el.querySelector('.product').classList.contains('product--no-media')) return;
    let thumbsSliderContent = el.querySelector(`${selectors.thumbsSlider} ${selectors.sliderContent}`);
    
    if(thumbsSliderContent !== null){
      let thumbSlideCount = parseInt(thumbsSliderContent.dataset.slideCount);
      
      var thumbOptions = {
        loop: parseInt(thumbsSliderContent.dataset.columnsMobile) >= thumbSlideCount,
        slidesPerView: thumbsSliderContent.dataset.columnsMobile,
        spaceBetween: thumbsSliderContent.dataset.spaceBetween,
        centeredSlides: thumbsSliderContent.dataset.centered === 'true',
        mousewheel: {
          enabled: thumbsSliderContent.dataset.mousewheel === 'true',
          forceToAxis: true
        },
        freeMode: thumbsSliderContent.dataset.freeMode === 'true',
        watchOverflow: true,
        grabCursor: true,
        navigation: {
          nextEl: `${sectionId} ${selectors.thumbsSlider} .slider__button--next`,
          prevEl: `${sectionId} ${selectors.thumbsSlider} .slider__button--prev`
        },
        breakpoints: {
          768: {
            loop: parseInt(thumbsSliderContent.dataset.columnsTablet) >= thumbSlideCount,
            slidesPerView: thumbsSliderContent.dataset.columnsTablet
          },
          1024: {
            loop: parseInt(thumbsSliderContent.dataset.columns) >= thumbSlideCount,
            slidesPerView: thumbsSliderContent.dataset.columns
          }
        }
      };
    }

    let slideCount = parseInt(sliderContent.dataset.slideCount);

    if(slideCount <= 1) return;

    var productOptions = {
      loop: parseInt(sliderContent.dataset.columnsMobile) >= slideCount,
      slidesPerView: sliderContent.dataset.columnsMobile,
      spaceBetween: sliderContent.dataset.spaceBetween,
      centeredSlides: sliderContent.dataset.centered === 'true',
      mousewheel: {
        enabled: sliderContent.dataset.mousewheel === 'true',
        forceToAxis: true
      },
      freeMode: sliderContent.dataset.freeMode === 'true',
      watchOverflow: true,
      grabCursor: true,
      autoHeight: true,
      on: {
        slideChange: function(){
          if(this.slides.length > 0){
            let curSlide = this.slides[this.realIndex];
            theme.sliders.playActiveMedia(curSlide);
            theme.sliders.preventStickyHeader();
          }
        }
      },
      breakpoints: {
        768: {
          loop: parseInt(sliderContent.dataset.columnsTablet) >= slideCount,
          slidesPerView: sliderContent.dataset.columnsTablet,
          thumbs: {
            enabled: el.dataset.desktopLayout === 'thumbnail_slider'
          }
        },
        1024: {
          loop: parseInt(sliderContent.dataset.columns) >= slideCount,
          slidesPerView: sliderContent.dataset.columns
        }
      }
    };

    if(sliderContent.dataset.showArrows){
      productOptions.navigation = {
        nextEl: `${sectionId} ${selectors.productSlider} .slider__button--next`,
        prevEl: `${sectionId} ${selectors.productSlider} .slider__button--prev`
      };
    }

    if(el.dataset.mobileLayout === 'pagination'){
      productOptions.breakpoints['1024'].pagination = {
        enabled: false
      };

      productOptions.pagination = {
        enabled: true,
        type: sliderContent.dataset.paginationType,
        el: `${sectionId} ${selectors.sliderPagination}`,
        clickable: sliderContent.dataset.dotsClickable === 'true'
      };
    }

    if(el.dataset.desktopLayout === 'pagination'){
      productOptions.breakpoints['1024'].pagination = {
        enabled: true
      }
    }

    var instance = {
      id: id
    };

    if(slideCount > window.theme.config.maxPagination && sliderContent.dataset.direction === 'horizontal'){
      if(sliderContent.dataset.dynamicBullets === 'true'){
        productOptions.pagination.dynamicBullets = true;
      }
    }

    if(el.dataset.mobileLayout !== 'columns' || el.dataset.mobileLayout !== 'stacked'){
      var thumbsSlider = new Swiper(`${sectionId} ${selectors.thumbsSlider} ${selectors.sliderContent}`, thumbOptions);

      productOptions.thumbs = {
        multipleActiveThumbs: false,
        autoScrollOffset: 1,
        swiper: thumbsSlider,
        enabled: el.dataset.mobileLayout === 'thumbnails'
      };

      instance.thumbsSlider = thumbsSlider;
    }

    var productSlider = new Swiper(`${sectionId} ${selectors.productSlider} ${selectors.sliderContent}`, productOptions);
    instance.productSlider = productSlider;

    if(el.dataset.desktopLayout === 'columns' || el.dataset.desktopLayout === 'stacked'){
      if(window.matchMedia('(min-width: 1024px)').matches){
        productSlider.destroy();
      }
    }

    let instanceIndex = productInstances.findIndex(i => i.id === instance.id);

    if(instanceIndex !== -1){
      productInstances.splice(instanceIndex, 1, instance);
    }else{
      productInstances.push(instance);
    }
  }

  const initTicker = (el, id) => {
    let sectionId = `[data-section-id="${id}"]`;
    let section = document.querySelector(sectionId);
    let tickerContent = el.querySelector(selectors.tickerContent);
    let tickerItems = tickerContent.querySelectorAll('.ticker__item');
    let tickerWidth = 0;
    let spaceBetween = parseInt(tickerContent.dataset.spaceBetween);
    let swiperSelector = `${sectionId} ${selectors.tickerContent}.ticker-initialized`;

    tickerItems.forEach(t => {
      let itemWidth = t.clientWidth + spaceBetween;
      tickerWidth += itemWidth;
    });

    while (tickerWidth < (section.clientWidth * 1.5)) {
      tickerItems.forEach(t => {
        tickerContent.querySelector('.swiper-wrapper').appendChild(t.cloneNode(true));
        let itemWidth = t.clientWidth + spaceBetween;
        tickerWidth += itemWidth;
      });
    }

    tickerContent.classList.add('ticker-initialized');

    var instance = {
      id: id,
      ticker: new Swiper(swiperSelector, {
        spaceBetween: spaceBetween,
        centeredSlides: true,
        speed: (parseFloat(tickerContent.dataset.speed) * 1000),
        autoplay: {
          delay: 0.1,
          reverseDirection: tickerContent.dataset.reverse === 'true'
        },
        loop: true,
        slidesPerView: 'auto',
        allowTouchMove: false,
      })
    };

    if(tickerInstances.find(i => i.id === instance.id)){
      tickerInstances[instance.id] = instance;
    }else{
      tickerInstances.push(instance);
    }
  }

  const playActiveMedia = (activeItem) => {
    theme.utils.pauseAllMedia();
    const deferredMedia = activeItem.querySelector('.deferred-media');
    if (deferredMedia) deferredMedia.loadContent(false);
  }

  const preventStickyHeader = () => {
    this.stickyHeader = document.querySelector('sticky-header');
    if (!this.stickyHeader) return;
    this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
  }

  return {
    init,
    initSlider,
    initSliders,
    initProductSliders,
    initProductSlider,
    initTicker,
    initTickers,
    playActiveMedia,
    destroySliders,
    destroyTickers,
    preventStickyHeader,
    instances,
    productInstances,
    tickerInstances,
  }
})();

theme.tabs = (function(){
  const selectors = {
    wrapper: '.tabs__wrapper',
    tablist: '.tabs__tablist[role="tablist"]',
    buttons: '.tab__button[role="tab"]',
    content: '.tab__content[role="tabpanel"]',
    activeTab: '.tab__button[aria-selected="true"]',
    navigation: {
      prev: '.tab__navigation--prev',
      next: '.tab__navigation--next'
    }
  }

  const setActiveTab = (id, section) => {
    const panels = section.querySelectorAll(selectors.content);
    const buttons = section.querySelectorAll(selectors.buttons);

    // hide all tab panels
    panels.forEach(panel => {
      panel.hidden = true;
    });

    // mark all tabs as unselected
    buttons.forEach(tab => {
      tab.setAttribute('aria-selected', false);
    });

    // set active tab and panel
    let activeTabTitle = document.getElementById(id);
    activeTabTitle.setAttribute('aria-selected', true);
    section.querySelector(`[aria-labelledby="${id}"]`).hidden = false;

    // scroll to selected tab
    section.querySelector(selectors.tablist).scrollLeft = activeTabTitle.offsetLeft - 30;

    // enable / disable arrows
    checkNavigation(activeTabTitle, section);
  }

  const tabButtonEvents = (tabSection) => {
    const tabButtons = tabSection.querySelectorAll(selectors.buttons);

    tabButtons.forEach(button => button.addEventListener('click', function(e){
      setActiveTab(e.currentTarget.id, tabSection);
    }));
  }

  const initTabSections = () => {
    const tabSections = document.querySelectorAll(selectors.wrapper);

    tabSections.forEach(tabSection => {
      tabButtonEvents(tabSection);
      tabTitlesArrows(tabSection);
      checkForHorizontalScrollbar(tabSection);

      let activeTabTitle = tabSection.querySelector(selectors.activeTab);
      checkNavigation(activeTabTitle, tabSection);

    });
  }

  const checkForHorizontalScrollbar = (section) => {
    let tabTitles = section.querySelector(selectors.tablist);
    let hasHorizontalScroll = theme.utils.hasScrollbar( tabTitles, 'horizontal' );

    if(hasHorizontalScroll){
      tabTitles.classList.add('has-scroll');
    }else{
      tabTitles.classList.remove('has-scroll');
    }
  }

  const checkNavigation = (activeTabTitle, section) => {
    let previousElement = activeTabTitle.previousElementSibling;
    let nextElement = activeTabTitle.nextElementSibling;

    if( previousElement.classList.contains(selectors.navigation.prev.replace('.','')) ){
      section.querySelector(selectors.navigation.prev).disabled = true;
    }else{
      section.querySelector(selectors.navigation.prev).disabled = false;
    }

    if( nextElement.classList.contains(selectors.navigation.next.replace('.','')) ){
      section.querySelector(selectors.navigation.next).disabled = true;
    }else{
      section.querySelector(selectors.navigation.next).disabled = false;
    }
  }

  const tabTitlesArrows = (section) => {
    window.addEventListener('resize', () => debounce(checkForHorizontalScrollbar(section), 600) );
    let prevTabButton = section.querySelector(selectors.navigation.prev);
    let nextTabButton = section.querySelector(selectors.navigation.next);

    prevTabButton.addEventListener('click', function(e){
      let nextElement = section.querySelector(selectors.activeTab).previousElementSibling;
      if(!nextElement.classList.contains(selectors.navigation.prev.replace('.',''))){
        setActiveTab(nextElement.id, section);
      }
    });

    nextTabButton.addEventListener('click', function(e){
      let previousElement = section.querySelector(selectors.activeTab).nextElementSibling;
      if(!previousElement.classList.contains(selectors.navigation.next.replace('.',''))){
        setActiveTab(previousElement.id, section);
      }
    });
  }

  const init = () => {
    initTabSections();
  }

  return {
    init,
    initTabSections,
    setActiveTab,
    tabButtonEvents,
    selectors
  }
})();

theme.utils = (function(){
  const credits = () => {
    console.log(
      `%c${window.siteDetails.name}%c — %cProdigy Theme (${window.siteDetails.themeVersion}) | ${window.siteDetails.themeUrl}`,
      `font-weight: bold; color: ${window.siteDetails.primaryColor};`,
      '', // no styles
      'color: #000; font-style: italic;'
    );
  }

  const fetchConfig = (type = 'json') => {
    return {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
    };
  }

  // if dynamic buttons exist on the page, wait for google payments to load
  const ensureGoogleLoaded = () => {
    return new Promise(waitForGoogle);
    function waitForGoogle(resolve, reject) {
      if(document.querySelectorAll('.shopify-payment-button').length === 0) resolve();

      if (window.google && window.google.payments) resolve(window.google.payments);
      else setTimeout(waitForGoogle.bind(this, resolve, reject), 30);
    }
  }

  // https://stackoverflow.com/questions/16839698/jquery-getscript-alternative-in-native-javascript/61903296#61903296
  const getScript = url => new Promise((resolve, reject) => {
    const script = document.createElement('script')
    script.src = url
    script.async = true
    script.onerror = reject

    script.onload = script.onreadystatechange = () => {
      const loadState = this.readyState
      if (loadState && loadState !== 'loaded' && loadState !== 'complete') return
      script.onload = script.onreadystatechange = null
      resolve()
    }

    document.head.appendChild(script)
  });

  const removeTrapFocus = (elementToFocus = null) => {
    document.removeEventListener('focusin', trapFocusHandlers.focusin);
    document.removeEventListener('focusout', trapFocusHandlers.focusout);
    document.removeEventListener('keydown', trapFocusHandlers.keydown);

    if (elementToFocus) elementToFocus.focus();
  }

  const getFocusableElements = (container) => {
    return Array.from(
      container.querySelectorAll(
        "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
      )
    );
  }

  const pauseAllMedia = (context = '') => {
    if(context === '') context = document;

    context.querySelectorAll('.js-youtube').forEach((video) => {
      video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
    });
    context.querySelectorAll('.js-vimeo').forEach((video) => {
      video.contentWindow.postMessage('{"method":"pause"}', '*');
    });
    context.querySelectorAll('video').forEach((video) => video.pause());
    context.querySelectorAll('product-model').forEach((model) => {
      if (model.modelViewerUI) model.modelViewerUI.pause();
    });
  }

  const setButtonLoading = (buttonEl) => {
    buttonEl.setAttribute('aria-disabled', true);
    buttonEl.classList.add('loading');
    buttonEl.querySelector('.loading-overlay__spinner').classList.remove('hidden');
  }

  const setButtonFinished = (buttonEl) => {
    buttonEl.setAttribute('aria-disabled', false);
    buttonEl.classList.remove('loading');
    buttonEl.querySelector('.loading-overlay__spinner').classList.add('hidden');
  }

  const hasScrollbar = (element, dir) => {
    dir = (dir === 'vertical') ? 'scrollTop' : 'scrollLeft';
    let res = !! element[dir];

    if (!res) {
      element[dir] = 1;
      res = !!element[dir];
      element[dir] = 0;
    }

    return res;
  }

  const parseAltText = (alt, separator = '||') => {
    var obj = {};
    let text = alt.split(separator);

    if(text.length > 1){
      text.map(t => {
        let split = t.split(':');
        obj[split[0].trim()] = split[1].trim();
      });
    }else{
      return false;
    }

    return obj;
  }

  const debounce = (func, wait, immediate) => {
    var timeout;
    return function(){
      var context = this, args = arguments;
      var later = () => {
        timeout = null;
        if (!immediate) func.apply(context, args);
      };
      var callNow = immediate && !timeout;
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
      if (callNow) func.apply(context, args);
    };
  };

  const stripHTMLTags = str => str.replace(/<[^>]*>/g, '');

  const getSectionInnerHTML = (html, selector) => {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  let timer, idleSeconds = 0;

  function resetTimer() {
      clearInterval(timer);
      idleSeconds = 0;

      let event = new CustomEvent('prodigy:idle-timer:reset', {
        detail: {
          idleSeconds
        }
      });

      window.dispatchEvent( event );
      timer = setInterval(startIdleTimer, 1000);
  }

  const startIdleTimer = () => {
    idleSeconds++;
    let event = new CustomEvent('prodigy:idle-timer:updated', {
      detail: {
        elapsed: idleSeconds
      }
    });

    window.dispatchEvent( event );
  }

  const initIdleTimer = () => {
    window.onload = resetTimer;
    window.onmousemove = resetTimer;
    window.onmousedown = resetTimer;
    window.ontouchstart = resetTimer;
    window.onclick = resetTimer;
    window.onkeydown = resetTimer;
  }

  const scrollAmount = () => {
    const debouncedScroll = theme.utils.debounce(() => {
      let scrollPercent = window.scrollY / (document.body.offsetHeight - window.innerHeight);
      let scrollPercentRounded = Math.round(scrollPercent * 100);

      let event = new CustomEvent('prodigy:scroll', {
        detail: {
          percentage: scrollPercentRounded,
          pixels: window.scrollY
        }
      });

      window.dispatchEvent(event);
    }, 300);

    window.addEventListener('scroll', debouncedScroll);
    debouncedScroll();
  }

  return {
    credits,
    debounce,
    ensureGoogleLoaded,
    fetchConfig,
    getFocusableElements,
    getScript,
    getSectionInnerHTML,
    hasScrollbar,
    initIdleTimer,
    parseAltText,
    pauseAllMedia,
    removeTrapFocus,
    scrollAmount,
    setButtonFinished,
    setButtonLoading,
    stripHTMLTags,
  }
})();

theme.variants = (function(){
  var selectors = selectors || {
    productGrid: '.product-grid-container, .product-grid',
    swatchesWrapper: '.swatches',
    swatchesLabels: '.swatches .swatch__label',
    cardWrapper: '.product-card-wrapper',
    swatch: '.swatch',
    productLinks: '.card__media > a, .card__information > a, .card__information > h3 > a, .card__content .add-to-cart__wrapper > a',
    mainImage: '.card__media .media > img',
    variantImage: '.card__variant-image',
    priceWrapper: '.price',
    price: '.price .price__regular',
    salePrice: '.price .price__sale',
    addToCartButton: '.product-form button[name="add"], a.button[name="view-details"]',
    variantTitle: '.card__variant-title',
    addToCartForm: '.product-form [data-type="add-to-cart-form"]'
  };

  const addEventHandlers = () => {
    function mouseOverHandler(e){
      e.preventDefault();

      const variantImageSrc = this.dataset.src;
      const variantImage = this.closest(selectors.cardWrapper).querySelector(selectors.variantImage);

      if (this.dataset.src !== '') {
        variantImage.src = variantImageSrc;
        variantImage.classList.remove('opacity-0');
        variantImage.classList.add('opacity-100');
      }
    }

    function mouseLeaveHandler(e){
      e.preventDefault();
      const variantImage = this.closest(selectors.cardWrapper).querySelector(selectors.variantImage);

      if (this.dataset.src !== '') {
        variantImage.classList.add('opacity-0');
        variantImage.classList.remove('opacity-100');
      }
    }

    function clickHandler(e){
      e.preventDefault();
      
      const cardWrapper = this.closest(selectors.cardWrapper);
      const variantImages = cardWrapper.querySelectorAll(selectors.mainImage);
      const mainImage = variantImages[0];
      const hoverImage = variantImages[1];
      const variantID = cardWrapper.querySelector('input[name="id"]');
      const addToCartButton = cardWrapper.querySelector(selectors.addToCartButton);
      const soldOutMessage = addToCartButton.querySelector('.sold-out-message');

      // mark as sold out
      if (this.dataset.soldOut) {
        addToCartButton.setAttribute('aria-disabled', true);
        addToCartButton.querySelector('span').classList.add('hidden');
        soldOutMessage.classList.remove('hidden');
      } else {
        addToCartButton.setAttribute('aria-disabled', false);
        addToCartButton.querySelector('span').classList.remove('hidden');
        soldOutMessage.classList.add('hidden');
      }

      // update product price
      if (this.dataset.compareAtPrice) {
        cardWrapper.querySelector(selectors.priceWrapper).classList.add('price--on-sale');
        cardWrapper.querySelector(selectors.salePrice).querySelector('.price-item--sale').innerHTML = this.dataset.price;
        cardWrapper.querySelector(selectors.salePrice).querySelector('.price-item--regular').innerHTML = this.dataset.compareAtPrice;
      } else {
        cardWrapper.querySelector(selectors.priceWrapper).classList.remove('price--on-sale');
        cardWrapper.querySelector(selectors.price).querySelector('.price-item--regular').innerHTML = this.dataset.price;
      }

      cardWrapper.querySelectorAll(selectors.productLinks).forEach(link => {
        link.setAttribute('href', this.dataset.url);
      });

      // reset checked
      cardWrapper.querySelector(selectors.swatchesWrapper).querySelectorAll('input[type="radio"]').forEach(input => {
        input.removeAttribute('checked');
      });
      cardWrapper.querySelector('.swatch--active').classList.remove('swatch--active');
      cardWrapper.querySelector('label.is-selected').classList.remove('is-selected');
      this.querySelector('input[type="radio"]').setAttribute('checked', 'checked');
      this.querySelector('label').classList.add('is-selected');
      this.classList.add('swatch--active');

      if (this.dataset.src !== '') {
        mainImage.setAttribute('alt', this.dataset.alt);
        mainImage.setAttribute('src', this.dataset.src);
        mainImage.setAttribute('srcset', this.dataset.srcset);
      }

      if (this.dataset.hoverSrc !== '') {
        hoverImage.setAttribute('alt', this.dataset.alt);
        hoverImage.setAttribute('src', this.dataset.hoverSrc);
        hoverImage.setAttribute('srcset', this.dataset.hoverSrcset);
      }

      variantID.value = this.dataset.variantId;
      cardWrapper.querySelector(selectors.variantTitle).innerHTML = this.dataset.value;

      const variantChanged = new CustomEvent('prodigy:product-card:variant-changed', {
        detail: {
          variantID: this.dataset.variantId,
          swatch: this
        }
      });

      window.dispatchEvent( variantChanged );
    }

    document.querySelectorAll(selectors.productGrid).forEach(grid => {
      grid.querySelectorAll(selectors.swatch).forEach(swatch => {
        swatch.addEventListener('mouseover', mouseOverHandler, false);
        swatch.addEventListener('mouseleave', mouseLeaveHandler, false);
        swatch.addEventListener('click', clickHandler, false);
      });
    });
  }

  const init = () => {
    if( document.querySelectorAll(selectors.productGrid).length > 0 ){
      addEventHandlers();
    }

    window.addEventListener('prodigy:product-recommendations:init', function(){
      addEventHandlers();
    });

    window.addEventListener('prodigy:facet-filters:loaded', function(){
      addEventHandlers();
    });

    window.addEventListener('prodigy:wishlist-drawer:loaded', function(){
      addEventHandlers();
    });
  }

  return {
    init
  }
})();

theme.wishlist = (function(){
  const selectors = {
    section: '.section__wishlist-drawer',
    button: '[data-wishlist-button]',
    buttonText: '[data-wishlist-text]',
    drawer: '.wishlist-drawer',
    drawerOverlay: '.drawer__overlay',
    storageKey: 'prodigy:wishlist',
    trigger: '[data-wishlist-open]',
    closeTrigger: '[data-wishlist-close]',
    activeClass: 'in-wishlist',
    productCard: '#shopify-section-card-wishlist',
    productGridCard: '#shopify-section-card-wishlist-grid',
    productCardSection: 'card-wishlist',
    productGridCardSection: 'card-wishlist-grid',
    wishlistGrid: '[data-wishlist-grid]',
    wishlistDrawerGrid: '[data-wishlist-drawer-grid]',
    itemsWrapper: '.drawer__wishlist-items-wrapper',
    delimiter: ','
  };

  let activeElement = '';

  const setActiveElement = (element) => {
    activeElement = element;
  }

  const fetchWishlistCard = (handle) => {
    const productTileTemplateUrl = `${Shopify.routes.root}products/${handle}?sections=${selectors.productCardSection}`;
    return fetch(productTileTemplateUrl)
    .then(response => response.json())
    .then((response) => theme.utils.getSectionInnerHTML(response[selectors.productCardSection], selectors.productCard))
    .catch((err) => console.error(`[Shopify Wishlist] Failed to load content for handle: ${handle}`, err));    
  }

  const fetchWishlistGridCard = (handle) => {
    const productTileTemplateUrl = `${Shopify.routes.root}products/${handle}?sections=${selectors.productGridCardSection}`;
    return fetch(productTileTemplateUrl)
    .then(response => response.json())
    .then((response) => theme.utils.getSectionInnerHTML(response[selectors.productGridCardSection], selectors.productGridCard))
    .catch((err) => console.error(`[Shopify Wishlist] Failed to load content for handle: ${handle}`, err));
  }

  const loadWishlistProducts = async () => {
    const wishlist = get();    
    const requests = wishlist.map(fetchWishlistCard);
    const responses = await Promise.all(requests);

    // filter out non-existent products
    const existingProducts = responses.filter(r => new DOMParser().parseFromString(r, 'text/html').querySelector('.product-card--empty') === null);    
    const cards = existingProducts.join('');

    let grids = document.querySelectorAll(selectors.wishlistDrawerGrid);

    grids.forEach(grid => {
      grid.innerHTML = cards;
      let emptyEl = grid;
      if(grid.closest('.drawer')){
        emptyEl = grid.closest('.drawer');
      }

      cards.length ? emptyEl.classList.remove('is-empty') : emptyEl.classList.add('is-empty');
    });

    const event = new CustomEvent('prodigy:wishlist-drawer:loaded');
    window.dispatchEvent(event);
  }

  const loadWishlistGridProducts = async () => {
    const wishlist = get();
    const requests = wishlist.map(fetchWishlistGridCard);
    const responses = await Promise.all(requests);

    // filter out non-existent products
    const existingProducts = responses.filter(r => new DOMParser().parseFromString(r, 'text/html').querySelector('.product-card--empty') === null);    
    const cards = existingProducts.join('');

    let grids = document.querySelectorAll(selectors.wishlistGrid);

    grids.forEach(grid => {
      grid.innerHTML = cards;
      cards.length ? grid.classList.remove('is-empty') : grid.classList.add('is-empty');
    });

    const event = new CustomEvent('prodigy:wishlist-drawer:loaded');
    window.dispatchEvent(event);    
  }

  const clickHandler = (handle, el) => {
    let updatedWishlist = update(handle);
    let wishlistString = window.wishlistStrings.remove;

    if(el.classList.contains(selectors.activeClass)){
      wishlistString = window.wishlistStrings.add;
    }
    
    el.setAttribute('title', wishlistString);
    let buttonText = el.querySelector(selectors.buttonText);
    if(buttonText) buttonText.innerHTML = wishlistString;

    el.classList.toggle(selectors.activeClass);

    if(window.theme.settings.wishlist.openAfterAdd && updatedWishlist !== '') open(el);
  }

  const setupButtons = (buttons) => {
    buttons.forEach(button => {
      let productHandle = button.dataset.productHandle;
      let clonedButton = button.cloneNode(true); // clone button to remove existing events
      let wishlistString = window.wishlistStrings.remove;

      if(!productHandle) return console.error('Missing product handle attribute (data-product-handle)', clonedButton)
      if( contains(productHandle) ){
        clonedButton.classList.add(selectors.activeClass);
      }else{
        clonedButton.classList.remove(selectors.activeClass);
        wishlistString = window.wishlistStrings.add;
      }

      clonedButton.setAttribute('title', wishlistString);
      let buttonText = clonedButton.querySelector(selectors.buttonText);
      if(buttonText) buttonText.innerHTML = wishlistString;

      clonedButton.addEventListener('click', () => clickHandler(productHandle, clonedButton), false);

      button.replaceWith( clonedButton );
    });
  }

  const open = (triggeredBy) => {
    if (triggeredBy) setActiveElement(triggeredBy);

    setTimeout(() => {
      let drawer = document.querySelector(selectors.drawer);
      drawer.classList.add('animate', 'active');
    });

    let drawer = document.querySelector(selectors.drawer);

    drawer.addEventListener('transitionend', () => {
      const containerToTrapFocusOn = drawer.classList.contains('is-empty') ? drawer.querySelector('.drawer__inner-empty') : document.querySelector(selectors.drawer);
      const focusElement = drawer.querySelector('.drawer__inner') || drawer.querySelector('.drawer__close');
      trapFocus(containerToTrapFocusOn, focusElement);      
    }, { once: true });

    document.body.classList.add('overflow-hidden');
    document.body.classList.add('wishlist-drawer--open');

    window.dispatchEvent(new CustomEvent('prodigy:wishlist-drawer:opened'))
  }

  const close = () => {
    let drawer = document.querySelector(selectors.drawer);
    drawer.classList.remove('active');
    theme.utils.removeTrapFocus(activeElement);
    document.body.classList.remove('overflow-hidden');
    document.body.classList.remove('wishlist-drawer--open');

    window.dispatchEvent(new CustomEvent('prodigy:wishlist-drawer:closed'))
  }

  const setupTriggers = () => {
    let openTriggers = document.querySelectorAll(selectors.trigger);
    openTriggers.forEach(trigger => {
      trigger.addEventListener('click', () => open(trigger));
    });

    let closeTriggers = document.querySelectorAll(selectors.closeTrigger);    
    closeTriggers.forEach(trigger => {
      trigger.addEventListener('click', close);
    });
  }

  const get = () => {
    const wishlist = localStorage.getItem(selectors.storageKey) || false;
    if (wishlist) return wishlist.split(selectors.delimiter);
    return [];
  };
  
  const set = (array) => {
    const wishlist = array.join(selectors.delimiter);
    if (array.length) localStorage.setItem(selectors.storageKey, wishlist);
    else localStorage.removeItem(selectors.storageKey);
    
    const event = new CustomEvent('prodigy:wishlist:set', {
      detail: {
        wishlist
      }
    });
    window.dispatchEvent(event);

    return wishlist;
  };
  
  const update = (handle) => {
    const wishlist = get();
    const indexInWishlist = wishlist.indexOf(handle);
    if (indexInWishlist === -1) wishlist.push(handle);
    else wishlist.splice(indexInWishlist, 1);

    const event = new CustomEvent('prodigy:wishlist:updated', {
      detail: {
        wishlist
      }
    });
    window.dispatchEvent(event);

    return set(wishlist);
  };
  
  const contains = (handle) => {
    const wishlist = get();
    return wishlist.includes(handle);
  };
  
  const reset = () => {
    set([]);

    const event = new CustomEvent('prodigy:wishlist:reset');
    window.dispatchEvent(event);    
  };

  const initListeners = () => {
    let drawer = document.querySelector(selectors.drawer);
    drawer.querySelector(selectors.drawerOverlay).addEventListener('click', close);
    drawer.addEventListener('keyup', (evt) => evt.code === 'Escape' && close());

    window.addEventListener('prodigy:wishlist:set', (e) => {
      let buttons = document.querySelectorAll(selectors.button);
      loadWishlistProducts();
      loadWishlistGridProducts();
      setupButtons(buttons);
      theme.products.init();
    });

    window.addEventListener('prodigy:product-recommendations:init', function(){
      let buttons = document.querySelectorAll(selectors.button);
      setupButtons(buttons);
    });

    window.addEventListener('prodigy:wishlist-drawer:loaded', function(){
      let buttons = document.querySelectorAll(selectors.button);
      setupButtons(buttons);
      theme.products.init();
    })
  }

  const init = () => {
    let buttons = document.querySelectorAll(selectors.button);
    loadWishlistProducts();
    loadWishlistGridProducts();    
    setupButtons(buttons);
    setupTriggers();
    initListeners();

    const event = new CustomEvent('prodigy:wishlist:init', {
      detail: {
        wishlist: get()
      }
    });
    window.dispatchEvent(event);
  }

  return {
    selectors,
    init,
    open,
    close,
    get,
    set,
    update,
    contains,
    reset,
    setupButtons,
    fetchWishlistCard,
    loadWishlistProducts,
    loadWishlistGridProducts
  }
})();

if(document.readyState !== 'loading'){    
  if(document.getElementById(theme.ageVerification.selectors.modalId)) theme.ageVerification.init();
  theme.utils.credits();
  theme.utils.scrollAmount();
  theme.accordions.init();
  theme.anchorLinks.init();
  theme.cart.init();
  theme.countdown.init();
  theme.gridLayoutSwitcher.init();
  theme.header.init();
  theme.maps.init();
  theme.mobileMenu.init();
  theme.modals.init();
  theme.navigation.init();
  theme.products.init();
  theme.priceRange.init();
  theme.scrollTop.init();
  theme.sliders.init();
  theme.tabs.init();
  theme.variants.init();
  
  if(window.theme.settings.wishlistEnabled) theme.wishlist.init();
  if(window.theme.settings.scrollAnimationsEnabled) theme.scrollAnimations.init();
  
  window.dispatchEvent(new CustomEvent('prodigy:script:loaded'));  
}

class VariantSelects extends HTMLElement {
  constructor() {
    super();

    if(this.closest('.sticky-add-to-cart')){
      this.addEventListener('change', (evt) => this.onStickyVariantChange(evt));
    }else if(this.closest('.card')){
      this.addEventListener('change', this.onCardVariantChange);
    }else{
      this.addEventListener('change', this.onVariantChange);
      this.initSwatches();
    }

    this.updateOptions(this);
    this.updateMasterId();
    this.filterMedia();
  }

  onStickyVariantChange(evt) {
    this.updateOptions(document.querySelector('.sticky-add-to-cart'));

    // set current variant
    this.updateMasterId();

    // update variant pickers in main product form
    let optionWrapper = evt.target.closest('.option-wrapper');
    let optionIndex = optionWrapper.dataset.optionIndex;
    let productId = document.querySelector('.sticky-add-to-cart .variantJSON').dataset.productId;
    let mainProductSection = document.querySelector(`.section__product section[data-product-id="${productId}"]`);

    mainProductSection.querySelectorAll(`.option-wrapper[data-option-index="${optionIndex}"] fieldset`).forEach(fieldset => {
      fieldset.querySelectorAll('input').forEach(input => {
        input.removeAttribute('checked');
      });
      fieldset.querySelector(`input[value="${this.currentVariant.options[fieldset.dataset.optionIndex]}"]`).click();
    });

    mainProductSection.querySelectorAll(`.option-wrapper[data-option-index="${optionIndex}"] select`).forEach(select => {
      select.value = this.currentVariant.options[select.dataset.optionIndex];
    });
  }

  onCardVariantChange() {
    this.updateOptions(this);
    this.updateMasterId();
    this.updatePickupAvailability();
    this.updateInventory();
    this.removeErrorMessage();

    if (!this.currentVariant) {
      this.setUnavailable();
    } else {
      this.updateVariantInput();
      this.renderCardInfo();
      this.updateCardFeaturedImage();

      var variantEvent = new CustomEvent('prodigy:pdp:variant-changed', {
        detail: {
          variant: this.currentVariant,
          sectionID: this.dataset.sectionId
        }
      });

      window.dispatchEvent(variantEvent);
    }
  }

  onVariantChange() {
    this.updateOptions(this);
    this.updateMasterId();
    this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();
    this.updateInventory();
    this.removeErrorMessage();
    
    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.filterMedia();
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
      var variantEvent = new CustomEvent('prodigy:pdp:variant-changed', {
        detail: {
          variant: this.currentVariant,
          sectionID: this.dataset.sectionId
        }
      });

      window.dispatchEvent(variantEvent);
    }

    // if we're in a modal, don't update the sticky add to cart
    if(!this.closest('.modal')){
      this.updateStickyAddToCart();
    }
  }

  updateCardFeaturedImage() {
    if(this.currentVariant.featured_image !== null){
      let card = this.closest('.card');
      let productImage = card.querySelector('.card__media .media img');
      productImage.src = this.currentVariant.featured_image.src;
    }
  }

  filterMedia() {    
    var section = this.closest('[data-product-slider]');
    var filteredEvent = new CustomEvent('prodigy:pdp:variant-media-filtered', {
      detail: {
        section,
        variant: this.currentVariant
      }
    });

    if ( !this.currentVariant.featured_media || !this.closest('.product') ) return;

    if (this.closest('.product').dataset.hideVariantImages === "false") {
      // if hide variants is false, should swap featured image for variant
      var activeSlide = document.querySelector(`[data-media-id="${section.dataset.sectionId}-${this.currentVariant.featured_media.id}"]`);
      document.querySelectorAll(`[data-section-id="${section.dataset.sectionId}"] [data-media-id]`).forEach(el => el.classList.remove('is-active'));
      activeSlide.classList.add('is-active');
      activeSlide.parentElement.prepend(activeSlide);

      const activeMediaRect = activeSlide.getBoundingClientRect();
      // Don't scroll if the image is already in view
      if (activeMediaRect.top > -0.5) return;
      const top = activeMediaRect.top + window.scrollY;
      window.scrollTo({ top: top, behavior: 'smooth' });

      return
    };

    var selectors = {
      mainSlider: '.media-slider',
      thumbSlider: '.thumbnail-slider',
      thumbSelector: '.slider__slide[data-color]',
      modalGallery: '.product-media-modal__content'
    }

    var selected_attribute = '[data-color]';

    if( this.currentVariant.featured_media.alt ){
      let color = '';
      var altTextParsed = theme.utils.parseAltText( this.currentVariant.featured_media.alt );

      if(altTextParsed !== false){
        color = altTextParsed.color;
      }else{
        color = this.currentVariant.featured_media.alt;
      }
      
      selected_attribute = '[data-color="' + color + '"]';
    }

    var slideClasses = ['swiper-slide', 'slider__slide', 'slide--current-variant'];
    var media = document.querySelectorAll(`${selectors.mainSlider} ${selected_attribute}, ${selectors.thumbSlider} ${selected_attribute}`);
    var mediaGeneric = document.querySelectorAll(`${selectors.mainSlider} [data-color=""], ${selectors.thumbSlider} [data-color=""]`);

    document.querySelectorAll(selectors.thumbSelector).forEach(thumb => {
      thumb.style.setProperty('display', 'none', 'important');
      thumb.classList.remove(...slideClasses);
    });
    media.forEach((m,i) => {
      if(i === 0){
        m.classList.add('slide--is-active');
      }
      m.style.setProperty('display', 'block', 'important');
      m.classList.add(...slideClasses);
    })
    mediaGeneric.forEach(m => {
      m.style.setProperty('display', 'block', 'important');
      m.classList.add(...slideClasses);
    })

    document.querySelectorAll(`${selectors.modalGallery} [data-color]`).forEach(i => {
      i.style.setProperty('display', 'none', 'important');
      i.classList.remove(...slideClasses);
    })
    document.querySelectorAll(`${selectors.modalGallery} [data-color=""]`).forEach(i => {
      i.style.setProperty('display', 'block', 'important');
      i.classList.add(...slideClasses);
    })
    document.querySelectorAll(`${selectors.modalGallery} ${selected_attribute}`).forEach(i => {
      i.style.setProperty('display', 'block', 'important');
      i.classList.add(...slideClasses);
    })

    let variantMediaLength = document.querySelectorAll(`${selectors.modalGallery} [data-color=""]`).length + document.querySelectorAll(`${selectors.modalGallery} ${selected_attribute}`).length;

    section.setAttribute('data-slide-count', variantMediaLength);
    window.dispatchEvent(filteredEvent);
  }

  initSwatches() {
    if (document.querySelector('.product__info-wrapper .swatches')) {
      const optionIndex = document.querySelector('.swatches').dataset.optionIndex;
      const variantData = this.getVariantData();

      if (variantData[0].options.length > 1) return;

      variantData.map((variant) => {
        const variantSwatch = document.querySelector('.swatch[data-value="' + variant.options[optionIndex] + '"')

        if (!variant.available) {
          variantSwatch.classList.add("sold-out");
        } else {
          variantSwatch.classList.remove("sold-out");
        }
      });
    }
  }

  updateStickyAddToCart() {
    const container = '.sticky-add-to-cart';
    const selectors = {
      variantInput: `${container} input[name="id"]`,
      button: `${container} button[name="add"]`,
      buttonText: `${container} button[name="add"] span`,
      productImage: `${container} .product-image`,
      priceContainer: `${container} .price`,
      sale_compareAtPrice: `${container} .price__sale .price-item--regular`,
      sale_price: `${container} .price__sale .price-item--sale`,
      regularPrice: `${container} .price__regular .price-item--regular`
    };

    if(document.querySelectorAll(container).length === 0) return;

    // update variant pickers
    document.querySelectorAll(`${container} select`).forEach((select, index) => {
      select.value = this.currentVariant.options[index];
    });

    // update variant id / title
    document.querySelector(selectors.variantInput).value = this.currentVariant.id;

    // update add to cart button
    document.querySelector(selectors.button).disabled = !this.currentVariant.available;
    document.querySelector(selectors.buttonText).innerHTML = this.currentVariant.available ? window.variantStrings.addToCart : window.variantStrings.soldOut;

    // update product image
    if(this.currentVariant.featured_image){
      document.querySelector(selectors.productImage).src = this.currentVariant.featured_image.src;
    }

    // update product price
    if(this.currentVariant.compare_at_price){
      document.querySelector(selectors.priceContainer).classList.add('price--on-sale');
      document.querySelector(selectors.sale_compareAtPrice).innerHTML = theme.currency.formatMoney(this.currentVariant.compare_at_price);
      document.querySelector(selectors.sale_price).innerHTML = theme.currency.formatMoney(this.currentVariant.price);
    }else{
      document.querySelector(selectors.priceContainer).classList.remove('price--on-sale');
      document.querySelector(selectors.regularPrice).innerHTML = theme.currency.formatMoney(this.currentVariant.price);
    }
  }

  updateOptions(el) {
    const fieldsets = Array.from(el.querySelectorAll('fieldset'));
    const radioOptions = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    });

    radioOptions.push(...Array.from(el.querySelectorAll('select'), (select) => select.value));
  
    this.options = radioOptions;
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false);
    });

    if (!this.currentVariant) {
      this.setUnavailable();
      return;
    }

    if (this.currentVariant.color_description) {
      this.currentVariant.color_description = this.getColorData().find((variant) => {
        return variant.id == this.currentVariant.id
      }).color_description;
    }

  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const modalContent = document.querySelector(`#ProductModal-${this.dataset.sectionId} .product-media-modal__content`);
    if (modalContent){
      const newMediaModal = modalContent.querySelector(`[data-media-id="${this.currentVariant.featured_media.id}"]`);
      modalContent.prepend(newMediaModal);
    }

    window.dispatchEvent(new CustomEvent('prodigy:pdp:variant-media-updated', {
      detail: {
        section: this.closest('[data-product-slider]'),
        currentVariant: this.currentVariant,
        sectionId: this.dataset.sectionId
      }
    }));
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.sectionId}`);
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(`#product-form-${this.dataset.sectionId}, #product-form-installment-${this.dataset.sectionId}, #add-to-cart-${this.dataset.sectionId}`);
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  updateInventory() {
    const inventoryRemainingBlock = document.querySelector(`#InventoryRemaining-${this.dataset.sectionId}`);
    if(!inventoryRemainingBlock) return;

    const inventoryThreshold = parseInt(inventoryRemainingBlock.dataset.inventoryThreshold);
    const showAmount = inventoryRemainingBlock.dataset.showAmount === 'true';
    const inventoryJSON = JSON.parse(document.querySelector(`[data-section-id=${this.dataset.sectionId}] .product #variantsInventory`).textContent);
    const variantInventory = inventoryJSON.find(v => v.id === this.currentVariant.id);

    let translationString = window.inventoryStrings.lowNoAmount

    if(showAmount === true){
      translationString = window.inventoryStrings.lowAmount
      translationString = translationString.replace('[quantity]', variantInventory.inventory);
    }

    // if variant is sold out
    if(variantInventory.inventory === 0 || variantInventory.inventory > inventoryThreshold){
      inventoryRemainingBlock.querySelector('.inventory-remaining-content').classList.add('hidden');
    }else{
      inventoryRemainingBlock.querySelector('.inventory-remaining-content').classList.remove('hidden');
      inventoryRemainingBlock.querySelector('.inventory-remaining-content span').innerHTML = translationString;
    }
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('.product-form');
    if (productForm) theme.products.handleErrorMessage({
      section: productForm
    });
  }

  renderProductInfo() {
    fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.sectionId}`)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html')

        this.updateOptionsText(html, this.dataset.sectionId);

        const destination = document.getElementById(`price-${this.dataset.sectionId}`);
        const source = html.getElementById(`price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.sectionId}`);
        if (source && destination) destination.innerHTML = source.innerHTML;

        const price = document.getElementById(`price-${this.dataset.sectionId}`);

        if (price) price.classList.remove('invisible');
        this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut);

      });
  }

  renderCardInfo() {
    fetch(`${this.dataset.url}?variant=${this.currentVariant.id}`)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html')

        // replace add to cart
        const buttonSource = html.querySelector(`.section.section__product .product-form form`);
        const buttonDestination = document.getElementById(`add-to-cart-${this.dataset.sectionId}`);
        if (buttonSource && buttonDestination) buttonDestination.innerHTML = buttonSource.innerHTML;

        // replace price
        const priceSource = html.querySelector(`.section.section__product .price__container`);
        const priceDestination = document.querySelector(`#price-${this.dataset.sectionId} .price__container`);
        if (priceSource && priceDestination) priceDestination.innerHTML = priceSource.innerHTML;
      })
  }

  updateOptionsText(html, sectionId) {
    if (html !== null) {
      const variantOptions = html.querySelectorAll(`[data-section-id="${sectionId}"] .product__info-wrapper .option-wrapper`);
      var colorIndex = null;

      if(html.querySelector(`[data-section-id="${sectionId}"] .product__info-wrapper .swatches`)){
        colorIndex = html.querySelector(`[data-section-id="${sectionId}"] .product__info-wrapper .swatches`).dataset.optionIndex;
      }

      // for each option wrapper, update html and selected text
      variantOptions.forEach((opt) => {
        const currentIndex = opt.dataset.optionIndex;
        const selectorString = `[data-section-id="${sectionId}"] .product__info-wrapper .option-wrapper[data-option-index="${currentIndex}"]`;
        const htmlOpt = html.querySelector(selectorString);
        const currentOpt = document.querySelector(selectorString);

        const descriptionDestination = currentOpt.querySelector(".variant-description");
        const variantSelectedValue = currentOpt.querySelector(".variant-selected-value");

        currentOpt.innerHTML = htmlOpt.innerHTML;

        if(variantSelectedValue){
          variantSelectedValue.innerHTML = this.currentVariant.options[currentIndex];
        }

        if(descriptionDestination){
          if (this.currentVariant.color_description !== null && currentIndex === colorIndex && colorIndex !== null) {
            descriptionDestination.innerHTML = this.currentVariant.color_description;
            descriptionDestination.classList.remove('hidden');
          } else {
            descriptionDestination.classList.add('hidden');
          }
        }
      });
    }
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.sectionId}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    if (!addButton) return;

    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute('disabled');
      addButtonText.textContent = window.variantStrings.addToCart;
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.sectionId}`);
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.sectionId}`);
    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add('invisible');
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(document.querySelector(`#variantJSON-${this.dataset.sectionId}`).textContent);
    return this.variantData;
  }

  getProductOptions() {
    this.productOptions = this.productOptions || JSON.parse(document.querySelector('#productOptions').textContent);
    return this.productOptions;
  }

  getColorData() {
    this.colorData = this.colorData || JSON.parse(document.querySelector('#variantColorDescription').textContent);
    return this.colorData;
  }
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));

    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    });
  }
}

customElements.define('variant-radios', VariantRadios);